import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as RolesRouteMap from 'src/app/data/constants/roles';
import { Router } from '@angular/router';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { ToastrService } from 'ngx-toastr';
import { mergeMap, take, takeUntil } from 'rxjs/operators';
import { Subject, combineLatest } from 'rxjs'; 
import { FilterService } from "primeng/api";
import { AttorneyService } from 'src/app/services/attorney.service';
import { ApiServicesService } from 'src/app/modules/beneficiary/services/api-services.service';
import { USER_PERMISSIONS } from 'permission-library';
import { LookupService } from 'src/app/services/lookup-data.service';
import { ReferenceLibrary, TaskSummaryOverview, DEPENDENT_VISAS } from 'app-models';
import * as fromTask from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import * as Task from 'src/app/modules/superTask/task-state/actions/task.actions';
import { ReferenceLibraryService } from 'reference-library';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { CreateTaskService } from '../create-task/create-task.service';
import { DashboardWidgetsService } from 'src/app/services/dashboard-widgets.service';
import { standardImmClassification, standardSubtasks, standardVisas } from 'src/app/data/constants/standard-visas';
import { CommonQuetionsService } from 'common-quetions';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddClientCompanyComponent, AddClientCompanyService } from 'add-client-company';
import { AddPrimaryContactComponent, AddPrimaryContactService } from 'add-primary-contact';
import { AddBeneficiaryOrMemberComponent, AddBeneficiaryOrMemberService } from 'add-beneficiary-or-member';
import { APIDocumentChecklist } from 'base-document-checklist-library';
import { TaskAllocationService } from "src/app/services/task-allocation.service";
import { CustomQuestionnaireService } from "src/app/modules/custom-questionaire/services/custom-questionnaire.service";
import { UserRoleService } from 'src/app/services/user-role.service';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
@Component({
  selector: 'app-create-task-new',
  templateUrl: './create-task-new.component.html',
  styleUrls: ['./create-task-new.component.scss'],
  providers: [FilterService]
})
export class CreateTaskNewComponent implements OnInit {

  @Input() caseRequestCreateTask: any;
  @Output() afterCreateTask = new EventEmitter<any>();
  isCaseRequestCreateTask: boolean = true;
  isCreateTask: boolean = false;
  dynamicDialogRef: DynamicDialogRef;
  autoCompletePlaceholder: string = 'Enter/Select';
  emailPattern: any = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$';
  newTaskForm: FormGroup;
  destroy$ = new Subject<void>();
  formChangesSubscriptions: any[] = [];
  primaryCompanyId: number | null;
  userType = '';
  selectedVisa;
  visaTypeArray = ['L1A', 'L1B', 'E1', 'E2', 'E2C', 'TN1', 'TN2', 'H1-B'];
  OVisaTypeArray = ['O1A', 'O1B'];
  dependentVisaArray = DEPENDENT_VISAS;
  companyListAssociatedWithAttorney: any[] = [];
  filteredCompanies: any[] = [];
  petitionerUserList: any[] = [];
  filteredPetitionerUsers: any[] = [];
  beneficiaryList: any[] = [];
  filteredBeneficiaryList: any[] = [];
  taskTypeList: ReferenceLibrary[];
  subTaskType: ReferenceLibrary[];
  visaTypes: ReferenceLibrary[] = [];
  petitionTypes: ReferenceLibrary[] = [];
  immigrationStatus: any[] = [];
  petitionerCompanyList: any[] = [];
  combinedVisas = [];
  duplicatePetitionerList = {
    petitionType: [],
    company: [],
    beneficiaryList: [],
    selectedPetitionType: [],
    visaType: '',
    selectedBeneficiaryId: 0
  }
  isDuplicatedData: boolean = false;
  reSuperTask: any;
  permSuperTask: any;
  i140SuperTask: any;
  i485SuperTask: any;
  ds160SuperTask: any;
  immigrantType = '';
  selectedSubTaskTypeName: string;
  isImmigrant: boolean = false;
  fields: {
    disableIsOutsideImagility: boolean;
  } = {
      disableIsOutsideImagility: false
    };
  immCategoryCode: any;
  immClassificationCode: any;
  isExtension: boolean = false;
  visaTemplates = [];
  visaId = 0;
  visaTemplateJson = null;
  taskJson = null;
  stepJson = null;
  //beneDetails;
  selectedSubTask = '';
  selectedTaskType: any;
  dependentList: any[] = [];
  filteredDependentList: any[] = [];
  isTaskForIndvdul: boolean = false;
  taskFor: string = 'company';
  dynamicModalData: any = {};
  selectedBeneficiary: any = {};
  selectedBeneficiaryName: any;
  attorneyCompanyId: any;
  attorneyList: any[] = [];
  selectedBenDetails: any;
  caseTaskTypeId: any;
  selectedAttorneyCid: any;
  isCaseRequestChange: boolean = false;

  stepTaskTimelineList = [];
  customStepTaskTimelineList = [];
  foreignFields: any = {};
  foreignCompanyList: any[] = [];
  companyRelationList: ReferenceLibrary[] = [];
  employeeList = [];
  isVDTemplate: boolean;
  templateType: string;
  treatyCountryList: any[] = [];
  showWarningMessage = false;
  isIndividualSponsor = false;
  isApplicantDisabled = false;
  hideSections: any = {};
  constructor(
    private router: Router,
    private fb: FormBuilder,
    protected store: Store<any>,
    private toast: ToastrService,
    private attorneyService: AttorneyService,
    private apiService: ApiServicesService,
    private lookupService: LookupService,
    private referenceLibraryService: ReferenceLibraryService,
    private petitionerService: PetitionerService,
    private createTaskService: CreateTaskService,
    private dashboardWidgetsService: DashboardWidgetsService,
    private taskListApiService: CommonQuetionsService,
    public dialogService: DialogService,
    private addClientCompanyService: AddClientCompanyService,
    private addPrimaryContactService: AddPrimaryContactService,
    private addBenMemberService: AddBeneficiaryOrMemberService,
    private apiDocService: APIDocumentChecklist,
    private _taskAllocationService: TaskAllocationService,
    private customQuestionsService: CustomQuestionnaireService,
    private userRoleService: UserRoleService,
    private cacheCountryService: CacheCountryService,
    private elementRef: ElementRef,
    
  ) {
    this.newTaskForm = this.fb.group({
      id: [null],
      beneficiary: [null, Validators.required],
      beneficiaryId: [null, Validators.required],
      company: [null, this.companyRequired.bind(this)],
      // company: [null],
      companyId: [null],
      petitionType: [null],
      visaType: [null],
      immCategoryCode: [null],
      immClassificationCode: [null],
      taskTypeCode: [null, Validators.required],
      //taskTypeCode: [null],
      superTaskTypeCode: ['NONIMMPET', Validators.required],
      authorizedSignatory: [null],
      authorizedSignatoryId: [null],
      templateType: [null],
      formType: ['I129FORM'],
      countryCode: ['USA'],
      language: ['ENG'],
      subTaskType: [null, Validators.required],
      //subTaskType: [null],
      isOutsideImagility: [false],
      isSelfSponsor: [false],
      primaryApplicant: [null, this.applicantRequired.bind(this)],
      preparerAttorneyId: [null]
    });
    this.hideSections = {
      hideSubTaskTypeSection: false,
      hideCompanyClientSection: false,
      hideOutSideImagilitySection: false,
    }
  }

  ngOnChanges(event: SimpleChanges) {
    if (event.caseRequestCreateTask && event.caseRequestCreateTask.currentValue) {
      if (sessionStorage.getItem('caseBenDetails')) {
        this.selectedBenDetails = JSON.parse(sessionStorage.getItem('caseBenDetails'));
        //console.log('this.selectedBenDetails', this.selectedBenDetails);
        // this.selectedBenId = sessionStorage.getItem('caseBenDetails');
      }
      //console.log('event.caseRequestCreateTask.currentValue', event.caseRequestCreateTask.currentValue);
      this.isCaseRequestCreateTask = false;
      //console.log('event.caseRequestCreateTask.currentValue1', this.newTaskForm);
      this.newTaskForm.addControl('attorneySelected', new FormControl(null, Validators.required));
      this.newTaskForm.addControl('lawFirmSelected', new FormControl(null, Validators.required));
      const payload = {
        pageNo: 1,
        recordsPerpage: 500,
        searchCriteria: "",
        searchText: "",
        sortBy: ""
      };
      this.attorneyCompanyId = parseInt(sessionStorage.getItem("companyId"));
      this.attorneyService
        .getAttorneysList(this.attorneyCompanyId, payload)
        .subscribe((data: any) => {
          if (data.status === 200) {
            data.data["attorneyDetailList"].forEach(item => {
              if (item.status == 'ACTV') {
                this.attorneyList.push({
                  name: item.companyName,
                  code: item.companyId
                });
              }
            })
          }
        })

    } else {
      this.isCaseRequestCreateTask = true;
      this.newTaskForm.removeControl('attorneySelected');
      this.newTaskForm.removeControl('lawFirmSelected');
    }
  }

  ngAfterViewInit() {
    this.translet();
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  } 
  onAttorneyChange(event) {
    this.newTaskForm.get('lawFirmSelected').patchValue(null);
    this.selectedAttorneyCid = event.value;
    const payload = {
      pageNumber: 0,
      recordsPerPage: 500,
      searchText: ""
    };
    this.userRoleService.getUsersList(event.value, payload).subscribe((user: any) => {
      this.employeeList = user['employees'];
      this.employeeList.forEach((data: any) => {
        data.name = data.firstName + " " + data.lastName
      });
      if (this.employeeList.length == 1) {
        this.newTaskForm.get('lawFirmSelected').patchValue(this.employeeList[0].id);
      }
    });
  }

  ngOnInit(): void {
    this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));
    this.userType = sessionStorage.getItem('userTypeRole');
    if(this.userType == 'Beneficiary'){
      // this.apiService.getBeneficiaryDetails(+sessionStorage.getItem('beneficiaryId'), 'self', '').subscribe(
      //   (res)=> {
      //     this.beneDetails = res;
          this.getCombinedVisas();
          this.getDependents(+sessionStorage.getItem('beneficiaryId'));
      //   }
      // )
    }
    combineLatest([
      this.referenceLibraryService.getReferenceData('IMMTYP'),
      this.referenceLibraryService.getReferenceData('SUPTSKTYP'),
      this.store.select(fromTask.getI485Details),
      this.store.select(fromTask.getDS160Details),
      this.store.select(fromTask.getREDetails),
      this.store.select(fromTask.getPERMDetails),
      this.store.select(fromTask.getI140Details)
    ])
      .pipe(take(1))
      .subscribe((response: any[]) => {
        this.i485SuperTask = response[2];
        this.immigrationStatus = response[0];
        this.ds160SuperTask = response[3];
        this.reSuperTask = response[4];
        this.permSuperTask = response[5];
        this.i140SuperTask = response[6];
        // this.immigrantType = this.immiStatus[0].code;
        this.immigrantType = 'VISA';
        this.taskTypeList = response[1];
        if (this.i485SuperTask) {
          this.newTaskForm.get('superTaskTypeCode').patchValue(this.i485SuperTask.superTaskTypeCode);
          this.onSuperTaskTypeChange({ value: this.i485SuperTask.superTaskTypeCode });
        } else if (this.ds160SuperTask) {
          this.newTaskForm.get('superTaskTypeCode').patchValue(this.ds160SuperTask.superTaskTypeCode);
          this.onSuperTaskTypeChange({ value: this.ds160SuperTask.superTaskTypeCode });
        } else if (this.reSuperTask) {
          this.newTaskForm.get('superTaskTypeCode').patchValue(this.reSuperTask.superTaskTypeCode);
          this.onSuperTaskTypeChange({ value: this.reSuperTask.superTaskTypeCode });
          this.getBeneficiaryList(this.reSuperTask.companyId);
        } else if (this.permSuperTask) {
          this.newTaskForm.get('superTaskTypeCode').patchValue(this.permSuperTask.superTaskTypeCode);
          this.onSuperTaskTypeChange({ value: this.permSuperTask.superTaskTypeCode });
        } else if (this.i140SuperTask) {
          this.newTaskForm.get('superTaskTypeCode').patchValue(this.i140SuperTask.superTaskTypeCode);
          this.onSuperTaskTypeChange({ value: this.i140SuperTask.superTaskTypeCode });
        } else if (this.newTaskForm.get('superTaskTypeCode').value) {
          this.getVisaType();
        }
      }); 
    this.formChangesSubscriptions[0] = this.newTaskForm.valueChanges
      .subscribe(() => {
        if (this.newTaskForm.dirty) {
          this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
          }));
        } else {
          this.store.dispatch(new MarkCleanFormAction({
            dirty: false
          }));
        }
      });
    this.taskListApiService.isAutoPopulateTemplate.subscribe(res => {
      this.isDuplicatedtoggle('duplicated', res);
    })

    this.addClientCompanyService.saveClientCompanySubject.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res && res.saved) {
        if (res.data) {
          const immCategoryCode = this.newTaskForm.get('immCategoryCode').value;
          if (immCategoryCode) {
            this.getCompanies(null, true, null, true, res.data);
          } else {
            const visaType = this.newTaskForm.get('visaType').value;
            this.getCompanies(null, false, visaType, true, res.data);
          }
          // this.onCompanyChange({petitionerId: res.data?.companyId});
          // this.onPeitionerUserChange({ id: res.data?.id });
        }
      }
    });
    this.addPrimaryContactService.savePrimaryContactSubject.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res && res.saved) {
        if (res.data) {
          if(this.userType=='Attorney'){
            this.getPetitionerUsers(this.newTaskForm.get('companyId').value, false, res.data);
          } else {
            this.getPetitionerUsers(this.newTaskForm.get('companyId').value, true, res.data);
          }
        }
      }
    });
    this.addBenMemberService.saveBenMemberSubject.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res && res.saved) {
        if (res.isAddingMember) {
          this.getDependents(this.userType == 'Beneficiary'? sessionStorage.getItem('beneficiaryId') : this.newTaskForm.get('beneficiaryId').value, true, res.data[0]);
        } else {
          if (this.newTaskForm.get('immCategoryCode').value && (this.newTaskForm.get('immCategoryCode').value === 'GCFLY' || this.newTaskForm.get('immClassificationCode').value === 'AFFDVTSUPT864')) {
            this.getSponsorList(true, res?.data);
          } else {
            const cId = this.foreignFields?.showForeignCompany ? this.newTaskForm.get('foreignCompanyId').value : (!this.newTaskForm.get('companyId').value ? this.primaryCompanyId : this.newTaskForm.get('companyId').value);
            this.getBeneficiaryList(cId, '', true, res.data);
          }
        }
      }
    });
    this.populateDefaultValues();
  }

  onSuperTaskTypeChange(event: any) {
    if (event?.value) {
      this.newTaskForm.patchValue({
        visaType: null,
        petitionType: null,
        immCategoryCode: null,
        immClassificationCode: null,
        subTaskType: null,
        templateType: null
      });
      this.showWarningMessage = false;
      this.visaTypes = [];
      this.visaTemplates = [];
      this.setNewTaskFormValue();
      this.getVisaType();
    }
  }

  onVisaTypeChange(event: any) {
    if (event?.value) {
      this.newTaskForm.patchValue({
        petitionType: null,
        immCategoryCode: null,
        immClassificationCode: null,
        subTaskType: null,
        templateType: null
      });
      this.setNewTaskFormValue();
      this.getPetitionType(event.value);
      if (this.dependentVisaArray.includes(this.newTaskForm.get('visaType').value) || ['U1', 'UD', 'I192U', 'APPLADCARDNONIM'].includes(this.newTaskForm.get('visaType').value)) {
        this.getSponsorList();
      }
    }
    //  this.hideSections.hideSubTaskTypeSection = this.newTaskForm.get('visaType').value === 'APPLADCARDNONIM';
    this.hideSections.hideCompanyClientSection = this.newTaskForm.get('visaType').value === 'APPLADCARDNONIM';
    this.hideSections.hideOutSideImagilitySection = this.newTaskForm.get('visaType').value === 'APPLADCARDNONIM';

  }

  onImmCategoryChange(event: any) {
    if (event?.value) {
      this.newTaskForm.patchValue({
        visaType: null,
        petitionType: null,
        immClassificationCode: null,
        subTaskType: null,
        templateType: null
      });
      this.setNewTaskFormValue();
      this.getImmigrationClassification();
    }
  }

  onImmClassificationChange(event: any) {
    if (event?.value) {
      this.newTaskForm.patchValue({
        visaType: null,
        petitionType: null,
        subTaskType: null,
        templateType: null
      });
      this.setNewTaskFormValue();
      this.onChangeImmigrationClassification();
      if (this.newTaskForm.value.immClassificationCode === 'AFFDVTSUPT864') {
        this.newTaskForm.patchValue({
          company: null
        });
        this.newTaskForm.get('compamny').updateValueAndValidity();
      }
      this.hideSections.hideCompanyClientSection = this.newTaskForm.get('immClassificationCode').value === 'APPLADCARDIMM';
      this.hideSections.hideOutSideImagilitySection = this.newTaskForm.get('immClassificationCode').value === 'APPLADCARDIMM';
    }
  }

  onPetitionTypeChange(event: any) {
    if (event?.value) {
      this.newTaskForm.patchValue({
        immCategoryCode: null,
        immClassificationCode: null,
        subTaskType: null,
        templateType: null
      });
      this.setNewTaskFormValue();
      this.getSubTaskType();
      if (!this.isCaseRequestCreateTask && this.petitionerCompanyList.length > 0 && this.userType === 'Petitioner') {
        let currentCompanyData: any = this.petitionerCompanyList.find(item => item.id == JSON.parse(sessionStorage.getItem('companyId')));
        this.isCaseRequestChange = true;
        this.onCompanyChange(currentCompanyData);
      }
    }
  }

  onSubTaskTypeChange(event: any) {
    if (event?.value) {
      this.newTaskForm.patchValue({
        templateType: null
      });
      this.visaTemplateJson = null;
      this.getVisaTemplates();
      this.newTaskForm.get('taskTypeCode').setValue(event.value);
      this.setNewTaskFormValue();
    }
  }

  onTemplateTypeChange(event: any) {
    this.templateType = ""
    if (event?.value) {
      if (event.value === 'CWF') {
        this.templateType = "CWF"
        return
      }
      this.visaId = event.value;
      this.isVDTemplate = this.visaTemplates.find(x => x.visaId === this.visaId).isVDTemplate;
   // this.isVDTemplate = this.visaTemplates.find(x => x.visaId === this.visaId) ? true : false;
      this.getVisaTemplateJson();
      if (!this.i485SuperTask && !this.ds160SuperTask && !this.reSuperTask) {
        this.setNewTaskFormValue();
      }
    } else {
      this.isVDTemplate = false;
    }
  }

  getVisaTemplates(isBeneficiaryInitiated?) {
    this.visaTemplates = [];
    const payload = {
      countryCode: this.newTaskForm.value?.countryCode || 'USA',
      formType: this.newTaskForm.value?.formType || 'I129FORM',
      immCategoryCode: this.newTaskForm.value?.immCategoryCode,
      immClassificationCode: this.newTaskForm.value?.immClassificationCode,
      language: this.newTaskForm.value?.language || 'ENG',
      subTaskType: this.newTaskForm.value?.subTaskType,
      taskType: this.newTaskForm.value?.superTaskTypeCode,
      templateType: null,
      visaType: this.newTaskForm.value?.visaType,
      petitionType: this.newTaskForm.value?.petitionType,
      immClassification: null
    };
    const immiPayload: any = {
      countryCode: payload.countryCode,
      formType: payload.formType,
      immCategory: payload.immCategoryCode,
      immClassification: payload.immClassificationCode,
      language: payload.language,
      subTaskType: payload.subTaskType,
      // subTaskType : "I145",
      taskType: payload.taskType,
      templateType: null
    };

    if (payload.taskType === 'NONIMMPET' || payload.taskType === 'OTHER') {
      // payload.hasOwnProperty('property1')
      delete payload.immCategoryCode;
      delete payload.immClassificationCode;
      delete payload.immClassification;
    } else {
      delete payload.visaType;
      delete payload.petitionType;
    }
    const payloadReq = payload.taskType === 'NONIMMPET' || payload.taskType === 'OTHER' ? payload : immiPayload;
    this.createTaskService.getVisaTemplates(payloadReq)
      .pipe(take(1))
      .subscribe((response: any[]) => {
        this.visaTemplates = response || [];
      
        if (this.i485SuperTask) {
            this.store.dispatch(new Task.SetI485Petition(null));
            this.i485SuperTask = null;
            this.toast.info('No template created', 'No Template');
        } else if (this.ds160SuperTask) {
          if (this.visaTemplates && this.visaTemplates.length > 0) {
            //this.newTaskForm.get('templateType').patchValue(this.visaTemplates[0].visaId);
          } else {
            this.store.dispatch(new Task.SetDS160Petition(null));
            this.ds160SuperTask = null;
            this.toast.info('No template created', 'No Template');
          }
        } else if (this.reSuperTask || this.permSuperTask || this.i140SuperTask) {
          if (this.visaTemplates && this.visaTemplates.length === 0) {
            this.closeTemplateSelectionDialog();
          }
        }
        // else if (this.visaTemplates && this.visaTemplates.length > 0) {
        //   this.newTaskForm.get('templateType').patchValue(this.visaTemplates[0].visaId);
        // } else if (this.newTaskForm.get('templateType').value) {
        //   this.newTaskForm.get('templateType').patchValue(null);
        // }
        if (this.newTaskForm.get('templateType').value) {
          this.newTaskForm.get('templateType').patchValue(null);
        }
       
        if ((standardVisas.includes(payload.visaType) && payload.subTaskType == 'PETITION') || standardImmClassification.includes(payload.immClassification) || standardSubtasks.includes(payload.subTaskType)) {
          this.visaTemplates.push({
            'visaId': '',
            'visaName': 'STANDARD WORKFLOW',
            isVDTemplate: false
          });
          if (this.newTaskForm.get('visaType').value == 'H1-B' && this.newTaskForm.get('subTaskType').value == 'PETITION') {
            this.visaTemplates.push({
              'visaId': 'CWF', 'visaName': 'SIMPLIFIED H1B', isVDTemplate: false
            });
            this.visaTemplates = this.visaTemplates.filter(x=>x.visaName !='SingleStep_H1B'); // temporary fix to hide single step vd
          }
        }
        this.isVDTemplate = false;
        if (this.visaTemplates?.length > 0) {
          this.visaTemplates = this.visaTemplates.map(x => {
            return {
              ...x,
              isVDTemplate: x.isVDTemplate ?? true
            };
          });
        }
        if (this.visaTemplates && this.visaTemplates.length === 1) {
          this.newTaskForm.get('templateType').patchValue(this.visaTemplates[0].visaId);
          this.onTemplateTypeChange({value:this.visaTemplates[0].visaId})
        } 

     //   console.log("this.visaTemplates",this.visaTemplates);
      });
  }

  getVisaTemplateJson() {
    if (this.visaId) {
      this.createTaskService.getVisaTemplateJSON(this.visaId)
        .pipe(take(1))
        .subscribe((res: any) => {
          this.visaTemplateJson = res || null;
          // if(this.visaTemplateJson && this.visaTemplateJson.taskTypeId){
          //   this.selectVisaTemplateForm.patchValue(this.visaTemplateJson.taskTypeId);
          // }
          this.taskJson = (res.taskJson) ? JSON.parse(res.taskJson) : null;
          this.stepJson = (res.stepJson) ? JSON.parse(res.stepJson) : null;
          if (this.taskJson) {
            this.newTaskForm.patchValue({
              formType: this.taskJson?.formType?.code,
              language: this.taskJson?.language?.code,
              country: this.taskJson?.country?.countryCode
            })
          }
          if (this.i485SuperTask || this.ds160SuperTask) {
            this.closeTemplateSelectionDialogAfterNewTaskFormCreated();
          }
        });
    }
  }

  closeTemplateSelectionDialogAfterNewTaskFormCreated() {
    this.closeTemplateSelectionDialog();
  }

  closeTemplateSelectionDialog() {
    if (this.i485SuperTask) {
      switch (this.i485SuperTask.subTaskTypeCode) {
        case 'I130':
          this.newTaskForm.get('companyId').patchValue(0);
          this.newTaskForm.patchValue({
            companyId: this.ds160SuperTask.companyId,
            company: {
              petitionerId: 0,
              petitionerName: 'Individual/Sponsor',
              contactPersonFirstName: '--',
              contactPersonLastName: '',
              contactPersonMiddleName: '',
            }
          });
          this.newTaskForm.get('beneficiaryId').patchValue(this.i485SuperTask.sponsorId);
          this.newTaskForm.get('isOutsideImagility').patchValue(this.i485SuperTask.isOutsideImagility);
          break;
        case 'PETITION':
          this.filterCompanies({ query: '' });
          if (this.filteredCompanies.length) {
            this.newTaskForm.patchValue({
              companyId: this.i485SuperTask.companyId,
              company: this.filteredCompanies.find((c) => c.petitionerId === this.i485SuperTask.companyId)
            });
            this.getPetitionerUsers(this.i485SuperTask.companyId, true, { id: this.i485SuperTask.signatoryId });
            this.getBeneficiaryList(this.i485SuperTask.companyId, '', true, { id: this.i485SuperTask.beneficiaryId });
          }
          break;
        case 'I140':
          this.filterCompanies({ query: '' });
          if (this.filteredCompanies.length) {
            this.newTaskForm.patchValue({
              companyId: this.i485SuperTask.companyId,
              company: this.filteredCompanies.find((c) => c.petitionerId === this.i485SuperTask.companyId)
            });
            this.getPetitionerUsers(this.i485SuperTask.companyId, true, { id: this.i485SuperTask.signatoryId });
            this.getBeneficiaryList(this.i485SuperTask.companyId, '', true, { id: this.i485SuperTask.beneficiaryId });
          }
          this.newTaskForm.get('isOutsideImagility').patchValue(this.i485SuperTask.isOutsideImagility);
          break;
        default:
          break;
      }
    } else if (this.ds160SuperTask) {
      switch (this.ds160SuperTask.subTaskTypeCode) {
        case 'DS160':
        case 'PETITION':
          this.filterCompanies({ query: '' });
          if (this.filteredCompanies.length) {
            this.newTaskForm.patchValue({
              companyId: this.ds160SuperTask.companyId,
              company: this.filteredCompanies.find((c) => c.petitionerId === this.ds160SuperTask.companyId)
            });
            this.getPetitionerUsers(this.ds160SuperTask.companyId, true, { id: this.ds160SuperTask.signatoryId });
            this.getBeneficiaryList(this.ds160SuperTask.companyId, '', true, { id: this.ds160SuperTask.beneficiaryId });
          }
          if (this.newTaskForm.get('isOutsideImagility')) {
            this.newTaskForm.get('isOutsideImagility').patchValue(this.ds160SuperTask.isOutsideImagility);
          }
          break;
        case 'I140':
          this.filterCompanies({ query: '' });
          if (this.filteredCompanies.length) {
            this.newTaskForm.patchValue({
              companyId: this.ds160SuperTask.companyId,
              company: this.filteredCompanies.find((c) => c.petitionerId === this.ds160SuperTask.companyId)
            });
            this.getPetitionerUsers(this.ds160SuperTask.companyId, true, { id: this.ds160SuperTask.signatoryId });
            this.getBeneficiaryList(this.ds160SuperTask.companyId, '', true, { id: this.ds160SuperTask.beneficiaryId });
          }
          this.newTaskForm.get('isOutsideImagility').patchValue(this.ds160SuperTask.isOutsideImagility);
          break;
      }
    } else if (this.reSuperTask && ['PWDEFILE'].includes(this.reSuperTask.subTaskTypeCode)) {
      this.filterCompanies({ query: '' });
      if (this.filteredCompanies.length) {
        this.newTaskForm.patchValue({
          companyId: this.reSuperTask.companyId,
          company: this.filteredCompanies.find((c) => c.petitionerId === this.reSuperTask.companyId)
        });
        this.getPetitionerUsers(this.reSuperTask.companyId, true, { id: this.reSuperTask.signatoryId });
        this.getBeneficiaryList(this.reSuperTask.companyId, '', true, { id: this.reSuperTask.beneficiaryId });
      }
      this.fetchDetailsForAttorney('beneficiaryId');
      this.newTaskForm.get('isOutsideImagility').patchValue(this.reSuperTask.isOutsideImagility);
    }
  }

  fetchDetailsForAttorney(formControlName: string) {
    if (this.newTaskForm.get(formControlName).value) {
      this.selectedBeneficiary = this.beneficiaryList
        .find(ele => ele.beneficiaryEmployeeId === this.newTaskForm.get(formControlName).value);
      this.selectedBeneficiaryName = this.beneficiaryList
        .filter(ele => ele.beneficiaryEmployeeId === this.newTaskForm.get(formControlName).value)[0].beneficiaryEmployeeFName;
    }
  }

  onChangeImmigrationClassification() {
    // let task: any = {};
    this.newTaskForm.patchValue({
      taskTypeCode: null,
    });
    this.selectedSubTaskTypeName = null;
    this.immCategoryCode = this.newTaskForm.get('immCategoryCode').value;
    this.immClassificationCode = this.newTaskForm.get('immClassificationCode').value;
    //this.showWarningMessage = this.immCategoryCode === 'GCOTHER' && ['TRVLDOCI131'].includes(this.immClassificationCode);
    this.selectedSubTask = '';
    this.selectedTaskType = '';
    if ((this.newTaskForm.get('immCategoryCode').value && ['GCOTHER', 'GCFLY'].includes(this.newTaskForm.get('immCategoryCode').value)) || this.immClassificationCode && this.immClassificationCode === 'AFFDVTSUPT864') {
      this.getSubTaskTypeListForFamilyImmigration();
    } else {
      this.getSubTaskTypeList();
    }
    if (!this.isCaseRequestCreateTask && this.petitionerCompanyList.length > 0 && this.userType === 'Petitioner') {
      let currentCompanyData: any = this.petitionerCompanyList.find(item => item.id == JSON.parse(sessionStorage.getItem('companyId')));
      this.isCaseRequestChange = true;
      this.onCompanyChange(currentCompanyData);
    }
  }

  getSubTaskTypeListForFamilyImmigration() {
    this.dashboardWidgetsService.getSubTaskTypeListForFamilyImmigration(
      this.newTaskForm.get('superTaskTypeCode').value, this.immCategoryCode,
      this.immClassificationCode)
      .pipe(take(1))
      .subscribe((response: any) => {
        if (response) {
          this.subTaskType = response;
          this.subTaskType = [...new Map(this.subTaskType.map(item => [item['code'], item])).values()];
          if (this.subTaskType && this.subTaskType.length > 0) {
            if (this.i485SuperTask) {
              const i485SubTask = this.subTaskType.find(x => x.code === 'I485');
              if (i485SubTask) {
                this.newTaskForm.get('subTaskType').patchValue('I485');
                this.newTaskForm.patchValue({
                  taskTypeCode: i485SubTask.code
                });
                this.selectedSubTaskTypeName = i485SubTask.name;
              }
            } else if (this.reSuperTask) {
              const reSubTask = this.subTaskType.find(x => x.code === 'RECEFF');
              if (reSubTask) {
                this.newTaskForm.get('subTaskType').patchValue('RECEFF');
                this.newTaskForm.patchValue({
                  taskTypeCode: reSubTask.code
                });
                this.selectedSubTaskTypeName = reSubTask.name;
              }
            } else if (this.permSuperTask) {
              const reSubTask = this.subTaskType.find(x => x.code === 'PERM');
              if (reSubTask) {
                this.newTaskForm.get('subTaskType').patchValue('PERM');
                this.newTaskForm.patchValue({
                  taskTypeCode: reSubTask.code
                });
                this.selectedSubTaskTypeName = reSubTask.name;
              }
            }
            else if (this.i140SuperTask) {
              const reSubTask = this.subTaskType.find(x => x.code === 'I140');
              if (reSubTask) {
                this.newTaskForm.get('subTaskType').patchValue('I140');
                this.newTaskForm.patchValue({
                  taskTypeCode: reSubTask.code
                });
                this.selectedSubTaskTypeName = reSubTask.name;
              }
            }
            //    }
            else if (this.subTaskType.length === 1) {
              this.newTaskForm.patchValue({
                taskTypeCode: this.subTaskType[0].code
              });
              this.selectedSubTaskTypeName = this.subTaskType[0].name;
            }
          }
        }
        this.onChangeFilterDropDown();
        this.getSponsorList();
      });
  }

  getSponsorList(updateNew: boolean = false, newBenData: any = {}) {
    this.createTaskService.getSponsorList(this.primaryCompanyId)
      .pipe(take(1))
      .subscribe((data: any) => {
        if (data && data.beneficiaryList && data.beneficiaryList.length > 0) {
          this.beneficiaryList = data.beneficiaryList.map(x => {
            return {
              ...x,
              fullName: `${x.beneficiaryEmployeeFName} ${x.beneficiaryEmployeeLName}`,
              beneficiaryEmployeeDisplayName: `${x.beneficiaryEmployeeFName} ${x.beneficiaryEmployeeLName}`
            };
          });
          if (updateNew && newBenData) {
            const newBen = this.beneficiaryList.find((ben) => ben.beneficiaryEmployeeId === newBenData?.id);
            this.newTaskForm.patchValue({
              beneficiary: newBen
            });
            this.onBenChange(newBen);
          }
        }
      });
  }

  handleSwitchChange() {
    // if (this.petitionTaskComponent) {
    //   this.petitionTaskComponent.getQuestionListForCreateTask();
    // }
    if (this.newTaskForm.get('superTaskTypeCode').value) {
      if (!this.newTaskForm.get('isOutsideImagility').value && this.newTaskForm.get('superTaskTypeCode').value === 'NONIMMPET') {
        this.newTaskForm.patchValue({
          taskTypeCode: 'PETITION'
        });
        this.selectedSubTaskTypeName = this.subTaskType.find(x => x.code === 'PETITION').name;
        this.onChangeFilterDropDown();
      } else if (this.newTaskForm.get('superTaskTypeCode').value === 'IMMPET' &&
        this.newTaskForm.get('immCategoryCode').value === 'GCFLY') {
        this.newTaskForm.patchValue({
          taskTypeCode: this.subTaskType[0].code
        });
        this.selectedSubTaskTypeName = this.subTaskType[0].name;
        this.onChangeFilterDropDown();
      }
    }
  }

  populateDefaultValues(resetForm: boolean = false, resetvalue: any = {}) {
    if (resetForm) {
      resetvalue = {
        ...resetvalue,
        superTaskTypeCode: 'NONIMMPET',
        formType: 'I129FORM',
        countryCode: 'USA',
        language: 'ENG',
        taskTypeCode: null
      }
      this.newTaskForm.reset(resetvalue);
      this.onSuperTaskTypeChange({ value: 'NONIMMPET' });
    }
    //  const creatingTaskFor = this.newTaskForm.get('creatingTaskFor').value;
    //  if(creatingTaskFor === 'individual'){
    //   this.getBeneficiaryList(this.primaryCompanyId);
    //  }
  }

  setNewTaskFormValue() {
    if (this.newTaskForm) {
      //this.newTaskForm.patchValue(this.newTaskForm.value);
      let a = this.newTaskForm.value;   //visaType
      if (a.petitionType === 'EXTNSN' || a.petitionType === 'AMEND') {
        this.duplicatePetitionerList.selectedPetitionType = a.petitionType;
        this.isExtension = true;
        sessionStorage.setItem('isDuplicated', 'true');
      } else {
        this.isExtension = false;
        sessionStorage.removeItem('isDuplicated');
      }
      if (a.visaType) {
        this.duplicatePetitionerList.visaType = a.visaType;
      }
    }
  }

  getVisaType() {
    this.newTaskForm.patchValue({
      visaType: null,
      petitionType: null,
      taskTypeCode: null,
      immCategoryCode: null,
      immClassificationCode: null,
      company: null,
      companyId: null,
      beneficiaryId: null,
      beneficiary: null,
      authorizedSignatoryId: null,
      authorizedSignatory: null,
      isOutsideImagility: false
    });
    this.selectedSubTaskTypeName = null;
    this.petitionTypes = [];
    this.petitionerCompanyList = [];
    this.companyListAssociatedWithAttorney = [];
    if (['NONIMMPET','OTHER'].includes(this.newTaskForm.get('superTaskTypeCode').value) ) {
      this.isImmigrant = false;
      this.referenceLibraryService.getReferenceData('VISATYP')
        .pipe(take(1))
        .subscribe((response: ReferenceLibrary[]) => {
          this.petitionTypes = [];
          if(['OTHER'].includes(this.newTaskForm.get('superTaskTypeCode').value)){
            this.visaTypes = response.filter(x=>x.code === 'I824APPFORACTION');
            this.newTaskForm.get('visaType').patchValue(this.visaTypes[0].code);
            this.onVisaTypeChange({ value: this.visaTypes[0].code });
          }else{
            this.visaTypes = response;
          }
         
          if (this.ds160SuperTask) {
            this.newTaskForm.get('visaType').patchValue(this.ds160SuperTask.taskTypeDetails.visaType);
            this.onVisaTypeChange({ value: this.ds160SuperTask.taskTypeDetails.visaType });
          } else {
            this.onChangeFilterDropDown();
          }
        });
    } else if (this.newTaskForm.get('superTaskTypeCode').value === 'IMMPET') {
      this.isImmigrant = true;
      this.getImmigrantClassificationAndCategory();
    }
  }

  getImmigrantClassificationAndCategory() {
    this.newTaskForm.patchValue({
      visaType: null,
      petitionType: null,
      immCategoryCode: null,
      immClassificationCode: null,
      company: null,
      companyId: null,
      beneficiaryId: null,
      isOutsideImagility: false
    });
    this.referenceLibraryService.getReferenceData('GCIMMCATG')
      .pipe(take(1))
      .subscribe((response: any) => {
        this.visaTypes = this.userType !== 'Attorney' ? (response as any[]).filter(x => x.code !== 'GCFLY') : response;
        // this.visaTypes = (response as any[]).filter(x => x.code !== 'GCFLY');  //changed regarding VD
        // this.visaTypes = response;
        if (this.i485SuperTask) {
          this.newTaskForm.get('immCategoryCode').patchValue(this.i485SuperTask.taskTypeDetails.immCategoryCode);
          this.onImmCategoryChange({ value: this.i485SuperTask.taskTypeDetails.immCategoryCode });
        } else if (this.ds160SuperTask) {
          this.newTaskForm.get('petitionType').patchValue(this.ds160SuperTask.taskTypeDetails.petitionType);
          this.onPetitionTypeChange({ value: this.ds160SuperTask.taskTypeDetails.petitionType });
        } else if (this.reSuperTask) {
          this.newTaskForm.get('immCategoryCode').patchValue(this.reSuperTask.taskTypeDetails.immCategoryCode);
          this.onImmCategoryChange({ value: this.reSuperTask.taskTypeDetails.immCategoryCode });
        } else if (this.permSuperTask) {
          this.newTaskForm.get('immCategoryCode').patchValue(this.permSuperTask.taskTypeDetails.immCategoryCode);
          this.onImmCategoryChange({ value: this.permSuperTask.taskTypeDetails.immCategoryCode });
        } else if (this.i140SuperTask) {
          this.newTaskForm.get('immCategoryCode').patchValue(this.i140SuperTask.taskTypeDetails.immCategoryCode);
          this.onImmCategoryChange({ value: this.i140SuperTask.taskTypeDetails.immCategoryCode });
        } else {
          this.onChangeFilterDropDown();
        }
      });
  }

  getImmigrationClassification() {
    this.newTaskForm.patchValue({
      visaType: null,
      petitionType: null,
      immClassificationCode: null,
      company: null,
      companyId: null,
      beneficiaryId: null,
      isOutsideImagility: false
    });
    this.petitionTypes = [];
    const requestArray = [];

    requestArray.push(this.referenceLibraryService.getReferenceData(this.newTaskForm.get('immCategoryCode').value));
    this.getCompanies(null, true, null);

    combineLatest(requestArray)
      .pipe(take(1))
      .subscribe((response: any[]) => {
        this.petitionTypes = response[0];
        // this.duplicateDataPetitionTypes = this.petitionTypes;

        // this.duplicatePetitionerList.petitionType = this.petitionTypes;
        // if (immCategoryCode && immCategoryCode !== 'GCFLY') {
        //   if (this.userType === 'Petitioner') {
        //     this.petitionerCompanyList = response[1];
        //     // this.duplicateDataPetitionerCompanyList = this.petitionerCompanyList;
        //     this.duplicatePetitionerList.company = this.petitionerCompanyList;
        //   } else if (this.userType === 'Attorney') {
        //     if (response[1] && response[1].petetionerList) {
        //       this.companyListAssociatedWithAttorney = response[1].petetionerList;
        //     this.duplicatePetitionerList.company = this.companyListAssociatedWithAttorney;

        //     }
        //   }
        // }
        if (this.i485SuperTask) {
          this.newTaskForm.get('immClassificationCode').patchValue(this.i485SuperTask.taskTypeDetails.immClassificationCode);
          this.onImmClassificationChange({ value: this.i485SuperTask.taskTypeDetails.immClassificationCode });
        } else if (this.reSuperTask) {
          this.newTaskForm.get('immClassificationCode').patchValue(this.reSuperTask.taskTypeDetails.immClassificationCode);
          this.onImmClassificationChange({ value: this.reSuperTask.taskTypeDetails.immClassificationCode });
        } else if (this.permSuperTask) {
          this.newTaskForm.get('immClassificationCode').patchValue(this.permSuperTask.taskTypeDetails.immClassificationCode);
          this.onImmClassificationChange({ value: this.permSuperTask.taskTypeDetails.immClassificationCode });
        } else if (this.i140SuperTask) {
          this.newTaskForm.get('immClassificationCode').patchValue(this.i140SuperTask.taskTypeDetails.immClassificationCode);
          this.onImmClassificationChange({ value: this.i140SuperTask.taskTypeDetails.immClassificationCode });
        } else {
          this.onChangeFilterDropDown();
        }
      });
  }

  getPetitionType(value) {
    const visaTypeSelected = value || null;
    this.newTaskForm.patchValue({
      petitionType: null,
      company: null,
      companyId: null,
      beneficiary: null,
      beneficiaryId: null,
      taskTypeCode: null,
      isOutsideImagility: false
    });
    this.selectedSubTaskTypeName = null;
    this.getCompanies(null, false, visaTypeSelected);
  }

  getSubTaskType() {
    this.newTaskForm.patchValue({
      taskTypeCode: null,
    });
    this.selectedSubTaskTypeName = null;
    if (this.newTaskForm.get('superTaskTypeCode').value && this.newTaskForm.get('petitionType').value && this.newTaskForm.get('visaType').value) {
      this.dashboardWidgetsService.getSubTasksType(this.newTaskForm.get('superTaskTypeCode').value, this.newTaskForm.get('petitionType').value, this.newTaskForm.get('visaType').value)
        .pipe(take(1))
        .subscribe((response: ReferenceLibrary[]) => {
          if (response) {
            if (!(this.userType === 'Attorney' && this.newTaskForm.get('visaType').value === 'H1-B')) {
              response = response.filter(ele => ele.code !== 'RFE');
            }
            if (response && response.length > 0 && response.some(x => x.code === 'PERM')) {
              response.push({
                code: "PERMSET",
                desc: "PERM (PWD, RE, PERM)",
                group: "TASKTYP",
                id: null,
                name: "PERM (PWD, RE, PERM)"
              });
            }
            this.subTaskType = response;
            this.subTaskType = [...new Map(this.subTaskType.map(item => [item['code'], item])).values()];
           
              if(['OTHER'].includes(this.newTaskForm.get('superTaskTypeCode').value) && this.subTaskType?.length > 0){
                const selectedI824SubTaskType = this.subTaskType.find(x=>x.code === 'PETITION');
                this.newTaskForm.get('subTaskType').patchValue(selectedI824SubTaskType.code);
                this.onSubTaskTypeChange({value:selectedI824SubTaskType.code});
             
            }else if (!this.newTaskForm.get('isOutsideImagility').value && !this.ds160SuperTask && !this.reSuperTask) {
              this.newTaskForm.patchValue({
                taskTypeCode: 'PETITION'
              });
              this.selectedSubTaskTypeName = this.subTaskType.find(x => x.code === 'PETITION').name;
              this.onChangeSubTaskType();
            } else if (this.ds160SuperTask) {
              const ds160SubTask = this.subTaskType.find(x => x.code === 'DS160');
              if (ds160SubTask) {
                this.newTaskForm.get('subTaskType').patchValue('DS160');
                this.newTaskForm.patchValue({
                  taskTypeCode: ds160SubTask.code
                });
                this.selectedSubTaskTypeName = ds160SubTask.name;
                this.onSubTaskTypeChange({ value: ds160SubTask.code });
              }
            } else if (this.subTaskType && this.subTaskType.length === 1) {
              this.newTaskForm.patchValue({
                taskTypeCode: this.subTaskType[0].code
              });
              this.selectedSubTaskTypeName = this.subTaskType[0].name;
              this.onSubTaskTypeChange({ value: this.subTaskType[0].code });
              this.onChangeSubTaskType();
            }
          }
        });
    }
  }

  getSubTaskTypeList() {
    this.dashboardWidgetsService.getSubTasksTypeListImmigrant(this.immCategoryCode, this.immClassificationCode)
      .pipe(take(1))
      .subscribe((response: any) => {
        const noNullResponse = (response.subTaskTypeList as any[]).filter(x => x);
        if (noNullResponse && noNullResponse.length > 0 && noNullResponse.some(x => x.code === 'PERM')) {
          noNullResponse.push({
            code: "PERMSET",
            createdBy: 1,
            description: "PERM (PWD, RE, PERM)",
            group: "TASKTYP",
            id: null,
            modifiedBy: null,
            name: "PERM (PWD, RE, PERM)",
            refGroupdesc: "Task Type"
          });
        }
        this.subTaskType = noNullResponse;
        this.subTaskType = [...new Map(this.subTaskType.map(item => [item['code'], item])).values()];
        if (this.subTaskType && this.subTaskType.length > 0) {
          if (this.i485SuperTask) {
            const i485SubTask = this.subTaskType.find(x => x.code === 'I485');
            if (i485SubTask) {
              this.newTaskForm.get('subTaskType').patchValue('I485');
              this.newTaskForm.patchValue({
                taskTypeCode: i485SubTask.code
              });
              this.selectedSubTaskTypeName = i485SubTask.name;
              this.onSubTaskTypeChange({ value: i485SubTask.code });
            }
          }
          else if (this.reSuperTask) {
            const reSubTask = this.subTaskType.find(x => x.code === 'RECEFF');
            if (reSubTask) {
              this.newTaskForm.get('subTaskType').patchValue('RECEFF');
              this.newTaskForm.patchValue({
                taskTypeCode: reSubTask.code
              });
              this.selectedSubTaskTypeName = reSubTask.name;
              this.onSubTaskTypeChange({ value: reSubTask.code });
            }
          }
          else if (this.permSuperTask) {
            const reSubTask = this.subTaskType.find(x => x.code === 'PERM');
            if (reSubTask) {
              this.newTaskForm.get('subTaskType').patchValue('PERM');
              this.newTaskForm.patchValue({
                taskTypeCode: reSubTask.code
              });
              this.selectedSubTaskTypeName = reSubTask.name;
              this.onSubTaskTypeChange({ value: reSubTask.code });
            }
          }
          else if (this.i140SuperTask) {
            const reSubTask = this.subTaskType.find(x => x.code === 'I140');
            if (reSubTask) {
              this.newTaskForm.get('subTaskType').patchValue('I140');
              this.newTaskForm.patchValue({
                taskTypeCode: reSubTask.code
              });
              this.selectedSubTaskTypeName = reSubTask.name;
              this.onSubTaskTypeChange({ value: reSubTask.code });
            }
          }
          else if (this.subTaskType.length === 1) {
            this.newTaskForm.patchValue({
              taskTypeCode: this.subTaskType[0].code
            });
            this.selectedSubTaskTypeName = this.subTaskType[0].name;
            this.onSubTaskTypeChange({ value: this.subTaskType[0].code });
          }
          if (this.newTaskForm.get('superTaskTypeCode').value === 'IMMPET' && this.newTaskForm.get('immCategoryCode').value !== 'GCEB') {
            this.getBeneficiaryList(this.primaryCompanyId);
          }

        }
        this.onChangeFilterDropDown();
      });
  }

  onChangeSubTaskType() {
    this.onChangeFilterDropDown();
  }

  onChangeFilterDropDown() {
    const task: any = {};
    task.visaType = this.newTaskForm.get('visaType').value;
    task.petitionType = this.newTaskForm.get('petitionType').value;
    task.taskTypeCode = this.newTaskForm.get('taskTypeCode').value;
    if (task.visaType && task.petitionType && task.taskTypeCode) {
      this.petitionerService.detectTaskFilterChanges(task, this.immigrantType);
    }
  }

  getCompanies(search: any = null, isImmigrant: boolean = false, visaTypeSelected: any, updateNew: boolean = false, newCompanyData: any = {}) {
    const reqJson: any = {
      searchText: search ? search : '',
      searchCriteria: '',
      sortBy: '',
      sortOrder: '',
      pageNumber: 0,
      recordsPerPage: 0
    };
    if(this.userType === 'Attorney'){
      reqJson.includeAssociate = true;
    }
    if (!isImmigrant) {
      let companyListReq;
      switch (visaTypeSelected) {
        case 'L1A':
        case 'L1B':
          this.newTaskForm.addControl('companyRelationCode', new FormControl(null, Validators.required));
          this.newTaskForm.addControl('foreignCompanyId', new FormControl(null, Validators.required));
          this.newTaskForm.addControl('treatyCountry', new FormControl(null));
          this.foreignFields = {
            showForeignCompany: true,
            showRelationshipOfUSCompanyWithForeignCompany: true,
            showTreatyCountry: false
          };
          this.fields.disableIsOutsideImagility = false;
          const reqArray = [
            this.createTaskService.getPetitionList(visaTypeSelected)
          ];
          if (this.userType === 'Petitioner') {
            companyListReq = this.petitionerService.getPetitionerClientList(this.primaryCompanyId, 'countryCode');
            reqArray.push(companyListReq);
          } else if (this.userType === 'Attorney') {
            companyListReq = this.attorneyService.getClientsList(this.primaryCompanyId, reqJson);
            reqArray.push(companyListReq);
          }
          reqArray.push(this.referenceLibraryService.getReferenceData('USFORGNCOMPREL'));
          combineLatest(reqArray)
            .pipe(take(1))
            .subscribe((response: any[]) => {
              this.companyRelationList = response[2];
              this.petitionTypes = response[0].map(x => {
                return {
                  code: x.code,
                  name: x.name,
                  id: x.id,
                  desc: x.description,
                  group: x.group
                };
              });
              // this.duplicateDataPetitionTypes = this.petitionTypes;
              this.duplicatePetitionerList.petitionType = this.petitionTypes;
              if (this.userType === 'Petitioner') {
                this.petitionerCompanyList = response[1].map((c) => { return { petitionerName: c.companyName, petitionerId: c.id, ...c }; });
                // this.duplicateDataPetitionerCompanyList = this.petitionerCompanyList;
                if (updateNew && newCompanyData) {
                  this.newTaskForm.patchValue({
                    companyId: newCompanyData.companyId,
                    company: this.petitionerCompanyList.find((c) => c.petitionerId === newCompanyData.companyId)
                  });
                  this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                }
                this.duplicatePetitionerList.company = this.petitionerCompanyList;
              } else if (this.userType === 'Attorney') {
                if (response[1] && response[1].petetionerList) {
                  this.companyListAssociatedWithAttorney = response[1].petetionerList;
                  this.duplicatePetitionerList.company = this.companyListAssociatedWithAttorney;
                  if (updateNew && newCompanyData) {
                    this.newTaskForm.patchValue({
                      companyId: newCompanyData.companyId,
                      company: this.companyListAssociatedWithAttorney.find((c) => c.petitionerId === newCompanyData.companyId)
                    });
                    this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                  }
                }
              }
              this.onChangeFilterDropDown();
            });
          break;
        case 'E1':
        case 'E2':
        case 'E2C':
          this.newTaskForm.addControl('companyRelationCode', new FormControl(null, Validators.required));
          this.newTaskForm.addControl('foreignCompanyId', new FormControl(null, Validators.required));
          this.newTaskForm.addControl('treatyCountry', new FormControl(null));
          this.foreignFields = {
            showForeignCompany: true,
            showRelationshipOfUSCompanyWithForeignCompany: true,
            showTreatyCountry: true
          };
          this.fields.disableIsOutsideImagility = false;
          const reqArr = [
            this.createTaskService.getPetitionList(visaTypeSelected)
          ];
          if (this.userType === 'Petitioner') {
            companyListReq = this.petitionerService.getPetitionerClientList(this.primaryCompanyId, 'countryCode');
            reqArr.push(companyListReq);
          } else if (this.userType === 'Attorney') {
            companyListReq = this.attorneyService.getClientsList(this.primaryCompanyId, reqJson);
            reqArr.push(companyListReq);
          }
          reqArr.push(this.referenceLibraryService.getReferenceData('USFORGNCOMPREL'));
          combineLatest(reqArr)
            .pipe(take(1))
            .subscribe((response: any[]) => {
              this.companyRelationList = response[2];
              this.petitionTypes = response[0].map(x => {
                return {
                  code: x.code,
                  name: x.name,
                  id: x.id,
                  desc: x.description,
                  group: x.group
                };
              });
              // this.duplicateDataPetitionTypes = this.petitionTypes;
              this.duplicatePetitionerList.petitionType = this.petitionTypes;
              if (this.userType === 'Petitioner') {
                this.petitionerCompanyList = response[1].map((c) => { return { petitionerName: c.companyName, petitionerId: c.id, ...c }; });
                // this.duplicateDataPetitionerCompanyList = this.petitionerCompanyList;
                if (updateNew && newCompanyData) {
                  this.newTaskForm.patchValue({
                    companyId: newCompanyData.companyId,
                    company: this.petitionerCompanyList.find((c) => c.petitionerId === newCompanyData.companyId)
                  });
                  this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                }
                this.duplicatePetitionerList.company = this.petitionerCompanyList;
              } else if (this.userType === 'Attorney') {
                if (response[1] && response[1].petetionerList) {
                  this.companyListAssociatedWithAttorney = response[1].petetionerList;
                  this.duplicatePetitionerList.company = this.companyListAssociatedWithAttorney;
                  if (updateNew && newCompanyData) {
                    this.newTaskForm.patchValue({
                      companyId: newCompanyData.companyId,
                      company: this.companyListAssociatedWithAttorney.find((c) => c.petitionerId === newCompanyData.companyId)
                    });
                    this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                  }
                }
              }
              this.onChangeFilterDropDown();
            });
          break;
        case 'H1-B':
          this.newTaskForm.removeControl('companyRelationCode');
          this.newTaskForm.removeControl('foreignCompanyId');
          this.newTaskForm.removeControl('treatyCountry');
          this.foreignFields = {
            showForeignCompany: false,
            showRelationshipOfUSCompanyWithForeignCompany: false,
            showTreatyCountry: false
          };
          if (this.userType === 'Petitioner') {
            companyListReq = this.petitionerService.getPetitionerClientList(this.primaryCompanyId);
          } else if (this.userType === 'Attorney') {
            companyListReq = this.attorneyService.getClientsList(this.primaryCompanyId, reqJson);
          }
          // combineLatest([
          //   this.createTaskService.getPetitionList(visaTypeSelected),
          //   companyListReq
          // ])
          combineLatest(
            this.userType === 'Beneficiary' ? [this.createTaskService.getPetitionList(visaTypeSelected)] : [this.createTaskService.getPetitionList(visaTypeSelected), companyListReq]
          )
            .pipe(take(1))
            .subscribe((response: any[]) => {
              this.petitionTypes = response[0].map(x => {
                return {
                  code: x.code,
                  name: x.name,
                  id: x.id,
                  desc: x.description,
                  group: x.group
                };
              });
              // this.duplicateDataPetitionTypes = this.petitionTypes;
              this.duplicatePetitionerList.petitionType = this.petitionTypes;
              if( response[1]) { 
                if (this.userType === 'Petitioner') {
                  this.petitionerCompanyList = response[1].map((c) => { return { petitionerName: c.companyName, petitionerId: c.id, ...c }; });
                  // this.duplicateDataPetitionerCompanyList = this.petitionerCompanyList;
                  this.duplicatePetitionerList.company = this.petitionerCompanyList;
                  if (updateNew && newCompanyData) {
                    this.newTaskForm.patchValue({
                      companyId: newCompanyData.companyId,
                      company: this.petitionerCompanyList.find((c) => c.petitionerId === newCompanyData.companyId)
                    });
                    this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                    this.getBeneficiaryList(newCompanyData.companyId);
                  }
                } else if (this.userType === 'Attorney') {
                  if (response[1] && response[1].petetionerList) {
                    this.companyListAssociatedWithAttorney = response[1].petetionerList;
                    this.duplicatePetitionerList.company = this.companyListAssociatedWithAttorney;
                    if (updateNew && newCompanyData) {
                      this.newTaskForm.patchValue({
                        companyId: newCompanyData.companyId,
                        company: this.companyListAssociatedWithAttorney.find((c) => c.petitionerId === newCompanyData.companyId)
                      });
                      this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                      this.getBeneficiaryList(newCompanyData.companyId);
                    }
                  }
                }
              }

              if (this.ds160SuperTask) {
                this.newTaskForm.get('petitionType').patchValue(this.ds160SuperTask.taskTypeDetails.petitionType);
                this.onPetitionTypeChange({ value: this.ds160SuperTask.taskTypeDetails.petitionType });
              } else {
                this.onChangeFilterDropDown();
              }
            });
          break;
        default:
          this.newTaskForm.removeControl('companyRelationCode');
          this.newTaskForm.removeControl('foreignCompanyId');
          this.newTaskForm.removeControl('treatyCountry');
          this.foreignFields = {
            showForeignCompany: false,
            showRelationshipOfUSCompanyWithForeignCompany: false,
            showTreatyCountry: false
          };
          this.fields.disableIsOutsideImagility = false;
          const req = [
            this.createTaskService.getPetitionList(visaTypeSelected)
          ];
          if (this.userType === 'Petitioner') {
            companyListReq = this.petitionerService.getPetitionerClientList(this.primaryCompanyId);
            req.push(companyListReq);
          } else if (this.userType === 'Attorney') {
            companyListReq = this.attorneyService.getClientsList(this.primaryCompanyId, reqJson);
            req.push(companyListReq);
          }
          combineLatest(req)
            .pipe(take(1))
            .subscribe((response: any[]) => {
              this.petitionTypes = response[0].map(x => {
                return {
                  code: x.code,
                  name: x.name,
                  id: x.id,
                  desc: x.description,
                  group: x.group
                };
              });
              // this.duplicateDataPetitionTypes = this.petitionTypes;
              this.duplicatePetitionerList.petitionType = this.petitionTypes;
              if(['OTHER'].includes(this.newTaskForm.get('superTaskTypeCode').value) && this.petitionTypes?.length > 0){
                  const selectedI824PetitionType = this.petitionTypes.find(x=>x.code === 'NEW');
                  this.newTaskForm.get('petitionType').patchValue(selectedI824PetitionType.code);
                  this.onPetitionTypeChange({ value: selectedI824PetitionType.code });
               
              }
              const indiVidualSposorOpt = {
                petitionerId: 0,
                petitionerName: 'Individual/Sponsor',
                contactPersonFirstName: '--',
                contactPersonLastName: '',
                contactPersonMiddleName: '',
              };
              if (this.userType === 'Petitioner') {
                if (response && response[1]) {
                  if (this.dependentVisaArray.includes(this.newTaskForm.get('visaType').value) || ['U1', 'UD', 'I192U'].includes(this.newTaskForm.get('visaType').value)) {
                    this.petitionerCompanyList = [indiVidualSposorOpt, ...response[1]];
                    this.newTaskForm.patchValue({
                      company: this.petitionerCompanyList[0]
                    });
                    this.onCompanyChange(this.petitionerCompanyList[0]);
                  } else {
                    this.petitionerCompanyList = response[1].map((c) => { return { petitionerName: c.companyName, petitionerId: c.id, ...c }; });
                  }
                }
                // this.duplicateDataPetitionerCompanyList = this.petitionerCompanyList;
                if (updateNew && newCompanyData) {
                  this.newTaskForm.patchValue({
                    companyId: newCompanyData.companyId,
                    company: this.petitionerCompanyList.find((c) => c.petitionerId === newCompanyData.companyId)
                  });
                  this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                  this.getBeneficiaryList(newCompanyData.companyId);
                }
                this.duplicatePetitionerList.company = this.petitionerCompanyList;
              } else if (this.userType === 'Attorney') {
                if (response[1] && response[1].petetionerList) {
                  if (this.dependentVisaArray.includes(this.newTaskForm.get('visaType').value) || ['U1', 'UD', 'I192U'].includes(this.newTaskForm.get('visaType').value)) {
                    this.companyListAssociatedWithAttorney = [indiVidualSposorOpt, ...response[1].petetionerList];
                    this.newTaskForm.patchValue({
                      company: this.companyListAssociatedWithAttorney[0]
                    });
                    this.onCompanyChange(this.companyListAssociatedWithAttorney[0]);
                  } else {
                    this.companyListAssociatedWithAttorney = response[1].petetionerList;
                  }
                  this.duplicatePetitionerList.company = this.companyListAssociatedWithAttorney;
                  if (updateNew && newCompanyData) {
                    this.newTaskForm.patchValue({
                      companyId: newCompanyData.companyId,
                      company: this.companyListAssociatedWithAttorney.find((c) => c.petitionerId === newCompanyData.companyId)
                    });
                    this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                    this.getBeneficiaryList(newCompanyData.companyId);
                  }
                }
              }
              this.onChangeFilterDropDown();
            });
          break;
      }
    } else {
      let companyListReq;
      if (this.userType === 'Petitioner') {
        companyListReq = this.petitionerService.getPetitionerClientList(this.primaryCompanyId);
      } else if (this.userType === 'Attorney') {
        companyListReq = this.attorneyService.getClientsList(this.primaryCompanyId, reqJson);
      }
      companyListReq.pipe(take(1))
        .subscribe((response: any) => {
          const immCategoryCode = this.newTaskForm.get('immCategoryCode').value;
          const individualSposor = {
            petitionerId: 0,
            petitionerName: 'Individual/Sponsor',
            contactPersonFirstName: '--',
            contactPersonLastName: '',
            contactPersonMiddleName: '',
          };
          this.duplicatePetitionerList.petitionType = this.petitionTypes;
          if (this.userType === 'Petitioner') {
            this.petitionerCompanyList = response.map((c) => { return { petitionerName: c.companyName, petitionerId: c.id, ...c }; });
            if (immCategoryCode !== 'GCEB') {
              this.petitionerCompanyList = [individualSposor, ...this.petitionerCompanyList];
              this.newTaskForm.patchValue({
                company: this.petitionerCompanyList[0]
              });
              this.onCompanyChange(this.petitionerCompanyList[0]);
            }
            this.duplicatePetitionerList.company = this.petitionerCompanyList;
            if (updateNew && newCompanyData) {
              this.newTaskForm.patchValue({
                companyId: newCompanyData.companyId,
                company: this.petitionerCompanyList.find((c) => c.petitionerId === newCompanyData.companyId)
              });
              this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
              this.getBeneficiaryList(newCompanyData.companyId);
            }
          } else if (this.userType === 'Attorney') {
            if (response && response.petetionerList) {
              if ((this.isImmigrant && this.visaTemplateJson) || (this.newTaskForm.value.immCategoryCode !== 'GCEB')) {
                this.companyListAssociatedWithAttorney = [individualSposor, ...response.petetionerList];
                if (immCategoryCode !== 'GCEB') {
                  this.newTaskForm.patchValue({
                    company: this.companyListAssociatedWithAttorney[0]
                  });
                  this.onCompanyChange(this.companyListAssociatedWithAttorney[0]);
                }
              } else {
                this.companyListAssociatedWithAttorney = response.petetionerList;
              }
              this.duplicatePetitionerList.company = this.companyListAssociatedWithAttorney;
              if (updateNew && newCompanyData) {
                this.newTaskForm.patchValue({
                  companyId: newCompanyData.companyId,
                  company: this.companyListAssociatedWithAttorney.find((c) => c.petitionerId === newCompanyData.companyId)
                });
                this.getPetitionerUsers(newCompanyData.companyId, true, newCompanyData);
                this.getBeneficiaryList(newCompanyData.companyId);
              }

            }
          }
        });
    }

  }

  createGroupedVisas(groupedVisas) {
    let outputGroupedVisas = []; 
    for (let key in groupedVisas) {
      if(key == 'immigrant') {
        outputGroupedVisas.push({
          label: 'IMMIGRANT VISAS',
          items: groupedVisas[key]?.map(obj => {return {label: `${obj.immCategory?.name} - ${obj.immClassification?.name} - ${obj.taskTypeRef?.name}`, value: obj}})
        })
      } else {
        outputGroupedVisas.push({
          label: 'NON-IMMIGRANT VISAS',
          items: groupedVisas[key]?.map(obj =>  { return {label : `${obj.visaType?.name} - ${obj.petitionType?.name} - ${obj.taskTypeRef?.name}`, value : obj }})
        })
      }
   }
   return outputGroupedVisas;
 }

 onVisaTypeSelectionChange(event) {
    console.log(event);
    this.newTaskForm.patchValue({
      templateType: null,
      immCategoryCode: event.value?.immCategory?.code,
      immClassificationCode: event.value?.immClassification?.code,
      subTaskType: event.value?.taskTypeRef?.code,
      taskTypeCode: event.value?.taskTypeRef?.code,
      superTaskTypeCode: event.value?.immClassification? 'IMMPET' : 'NONIMMPET',
      visaType: event.value?.visaType?.code,
      petitionType: event.value?.petitionType?.code
    })
    this.getVisaTemplates(true);
    this.getCompanyForBeneficiary();
    this.createTaskService.getBeneficiaryProfile(sessionStorage.getItem('beneficiaryId')).subscribe(
      (val) => {
        this.newTaskForm?.get('beneficiary').patchValue(val);
      }
    );
    this.newTaskForm?.get('beneficiaryId').patchValue(sessionStorage.getItem('beneficiaryId'));
    // const payload = {
    //   countryCode: this.newTaskForm.value?.countryCode || 'USA',
    //   formType: this.newTaskForm.value?.formType || 'I129FORM',
    //   immCategoryCode: this.newTaskForm.value?.immCategoryCode,
    //   immClassificationCode: this.newTaskForm.value?.immClassificationCode,
    //   language: this.newTaskForm.value?.language || 'ENG',
    //   subTaskType: this.newTaskForm.value?.subTaskType,
    //   taskType: this.newTaskForm.value?.superTaskTypeCode,
    //   templateType: null,
    //   visaType: this.newTaskForm.value?.visaType,
    //   petitionType: this.newTaskForm.value?.petitionType,
    //   immClassification: null
    // };
 }

 getCompanyForBeneficiary() {
  this.createTaskService.getCompanyForBeneficiary().subscribe(
    (val) => {
      this.newTaskForm.get('company').patchValue(val[0].attroneyName);
      this.newTaskForm.get('companyId').patchValue(val[0].attorneyId);
    }
  )
}

  getCombinedVisas() {
    this.apiService.getCombinedVisas().subscribe(
      (res) => {
        let tempGroupedObj = this.groupByImmClassification(res);
        this.combinedVisas = this.createGroupedVisas(tempGroupedObj);
      }
    )
  }

  groupByImmClassification(data) {
    return data.reduce((acc, obj) => {
        const key = obj.immClassification ? 'immigrant' : 'nonImmigrant';
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}

  filterCompanies(event: any) {
    let query = event.query;
    let filtered = [];
    let arrayTobeFiltered = (this.userType === 'Petitioner') ? this.petitionerCompanyList : this.companyListAssociatedWithAttorney;
    let addIndividualSponsorObj = this.newTaskForm.get('visaType').value && ['APPLADCARDNONIM','I824APPFORACTION'].includes(this.newTaskForm.get('visaType').value);
    if ((this.isImmigrant || addIndividualSponsorObj) && (this.visaTemplateJson || ['EB1ALIEN'].includes(this.newTaskForm.get('immClassificationCode').value)) && this.userType === 'Attorney' && !['TEMPPROTSTATI821','DACAI821D','NOTICEAPPEALMOTIONI2'].includes(this.newTaskForm.get('immClassificationCode').value)) {
      // if (!['EB4IMMJUVNL', 'EB4IMMRELGWRKR'].includes(this.newTaskForm.get('immClassificationCode').value)) {
      arrayTobeFiltered = [{
        petitionerId: 0,
        petitionerName: 'Individual/Sponsor',
        contactPersonFirstName: '--',
        contactPersonLastName: '',
        contactPersonMiddleName: '',
      }, ...arrayTobeFiltered];
      // }
    }

    const keyToFilter = (this.userType === 'Petitioner') ? 'companyName' : 'petitionerName';
    for (let i = 0; i < arrayTobeFiltered.length; i++) {
      let item = arrayTobeFiltered[i];
      if (item[keyToFilter].toLowerCase().indexOf(query.toLowerCase()) > -1) {
        filtered.push(item);
      }
    }
    this.filteredCompanies = filtered;
  }

  companyRequired(control: FormControl): { [s: string]: boolean } {
    if (this.newTaskForm &&
      (!this.newTaskForm.value.immCategoryCode ||
        (this.newTaskForm.value.immCategoryCode &&
          this.newTaskForm.value.immCategoryCode !== 'GCFLY' && this.newTaskForm.value.immClassificationCode !== 'AFFDVTSUPT864')) &&
      !control.value && this.hideSections.hideCompanyClientSection) {
      return { companyIsRequired: true };
    }
    return null;
  }

  applicantRequired(control: FormControl): { [s: string]: boolean } {
    if(this.userType == 'Beneficiary' && !control.value) {
      return { applicantIsRequired: true };
    }
    else if (this.newTaskForm && !this.newTaskForm.value.isSelfSponsor &&
      ((this.newTaskForm.value.superTaskTypeCode === 'NONIMMPET' && this.dependentVisaArray.includes(this.newTaskForm.value.visaType)) ||
        (this.newTaskForm.value.immCategoryCode &&
          (this.newTaskForm.value.immCategoryCode === 'GCFLY' || this.newTaskForm.value.immClassificationCode === 'AFFDVTSUPT864'))) && !control.value) {
      return { applicantIsRequired: true };
    }
    return null;
  }

  getBeneficiaryList(companyId, searchText: string = '', updateNew: boolean = false, newBenData: any = {}) {
    if (undefined === companyId) return;
    if(0 === companyId){ //in case if Individual/Sponser is selected from company dropdown IM-24967
      companyId = parseInt(sessionStorage.getItem('companyId'));
    }
    const beneficiaryParamPayload = {
      pageNumber: 1,
      recordsPerPage: 100,
      searchCriteria: 'beneficiary',
      searchText: searchText,
      sortBy: 'companyName',
      sortOrder: 'asc',
      status: ['ACTIVE']
    };
    this.apiService.getBeneficiariesByCompanyId(companyId, beneficiaryParamPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: Array<any>) => {
        if (data) { 
          this.beneficiaryList = data.map((ben) => { ben['fullName'] = `${ben.beneficiaryEmployeeFName}${ben.beneficiaryEmployeeMName ? ' ' + ben.beneficiaryEmployeeMName : ''} ${ben.beneficiaryEmployeeLName}`; return ben; });
          if (!this.isCaseRequestCreateTask) {
            if (this.selectedBenDetails) {
              let selectedBenId = parseInt(this.selectedBenDetails.beneficiaryEmployeeId)
              const reqBen = this.beneficiaryList.find((ben) => ben.beneficiaryEmployeeId === selectedBenId);
              this.newTaskForm.patchValue({
                beneficiary: reqBen
              });
              this.onBenChange(reqBen);
            }
          }
          if (updateNew && newBenData) {
            const newBen = this.beneficiaryList.find((ben) => ben.beneficiaryEmployeeId === newBenData?.id);
            this.newTaskForm.patchValue({
              beneficiary: newBen
            });
            this.onBenChange(newBen);
          }
        }
      });
  }

  filterBeneficiaries(event) {
    let query = event.query;
    let filtered = [];
  
    for (let i = 0; i < this.beneficiaryList.length; i++) {
      let item = this.beneficiaryList[i];
  
      // Check if query matches any of the fields (fullName, beneficiaryEmail, or alienRegNo)
      if (
        (item.fullName && item.fullName.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
        (item.beneficiaryEmail && item.beneficiaryEmail.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
        (item.alienRegNo && item.alienRegNo.toLowerCase().indexOf(query.toLowerCase()) > -1)
      ) {
        filtered.push(item);
      }
    }
  
    this.filteredBeneficiaryList = filtered;
  }

  getPetitionerUsers(compayId: number, updateNew: boolean = false, newContactData: any = {}) {
    if (compayId) {
      this.lookupService.getReviewersUser(compayId, USER_PERMISSIONS.PETITION_REVIEWER).subscribe((data: Array<any>) => {
        if(data!==null){
          this.petitionerUserList = data.map((emp) => { emp['fullName'] = `${emp.firstName}${emp.middleName ? ' ' + emp.middleName : ''} ${emp.lastName}`; return emp; });
          if (updateNew && newContactData) {
            const newContact = this.petitionerUserList.find((pu) => pu.id === newContactData?.id);
            this.newTaskForm.patchValue({
              authorizedSignatory: newContact
            });
            this.onPeitionerUserChange(newContact);
          }
        } else {
          this.petitionerUserList = [];
          this.newTaskForm.patchValue({
            authorizedSignatory: null
          });
        }
        
      });
    }
  }

  filterPetitionerUsers(event: any) {
    let query = event.query;
    let filtered = [];

    for (let i = 0; i < this.petitionerUserList.length; i++) {
      let item = this.petitionerUserList[i];
      if (item.fullName.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        filtered.push(item);
      }
    }

    this.filteredPetitionerUsers = filtered;
  }

  onCompanyChange(selectedItem: any,type?) {
    this.isIndividualSponsor = type && type === 'OPTIONCHANGEDFRMDRPDWN' && selectedItem?.petitionerName === "Individual/Sponsor" && selectedItem?.petitionerId === 0 ? true : false;
    const comapnyId = selectedItem.id ? selectedItem.id : ['EB4IMMOTH', 'EB4IMMJUVNL', 'EB4IMMRELGWRKR'].includes(this.newTaskForm.get('immClassificationCode').value) && this.isIndividualSponsor ? sessionStorage.getItem('companyId') : selectedItem.petitionerId;
    this.newTaskForm.patchValue({
      companyId: comapnyId
    });
    this.newTaskForm.patchValue({
      beneficiaryId: null,
      beneficiary: null,
      authorizedSignatoryId: null,
      authorizedSignatory: null
    });
    if (!(0 === comapnyId)) {
      this.getPetitionerUsers(this.newTaskForm.value.companyId);
    }
    const visaTypeSelected = this.newTaskForm.get('visaType').value;
    switch (visaTypeSelected) {
      case 'L1A':
      case 'L1B':
        this.petitionerService.getPetitionerClientList(this.newTaskForm.get('companyId').value, 'notInCountry')
          .pipe(take(1))
          .subscribe((response: any[]) => {
            this.foreignCompanyList = response;
          });
        break;
      case 'E1':
      case 'E2':
      case 'E2C':
        combineLatest([
          this.petitionerService.getForeignCompanyListForEVisa(visaTypeSelected, this.newTaskForm.get('companyId').value),
          this.petitionerService.getTreatyCountries(visaTypeSelected)
          //this.cacheCountryService.getCountry()
        ])
          .pipe(take(1))
          .subscribe((response: any[]) => {
            this.foreignCompanyList = response[0];
            if (response[1]?.length > 0) {
              this.treatyCountryList = response[1]?.map((c) => {
                c['labelWithCode'] = `${c.countryName} - ${c.phoneCode}`;
                return c;
              });
              // this.treatyCountryList = response[1]?.map((c) => {
              //   c['labelWithCode'] = `${c.countryName} - ${c.phoneCode}`;
              //   return c;
              // });
            }
          });
        // this.petitionerService.getForeignCompanyListForEVisa(visaTypeSelected, this.newTaskForm.get('companyId').value)
        //   .pipe(take(1))
        //   .subscribe((response: any[]) => {
        //     this.foreignCompanyList = response;
        //   });
        break;
      default:
        this.getBeneficiaryList(this.newTaskForm.value.companyId);
        break;
    }

    if (this.isCaseRequestChange) {
      this.newTaskForm.patchValue({
        company: selectedItem,
        companyId: selectedItem.id
      });
      this.isCaseRequestChange = false;
    }

  }

  onForeignCompanyChange(event: any) {
    const foreignCompanyId = this.newTaskForm.get('foreignCompanyId').value;
    this.getBeneficiaryList(foreignCompanyId);
    if (['E1', 'E2', 'E2C'].includes(this.newTaskForm.get('visaType').value)) {
      this.newTaskForm.patchValue({
        treatyCountry: this.foreignCompanyList.find(x => x.id === foreignCompanyId).countryName
      });
    }
  }

  onPeitionerUserChange(selectedItem: any) {
    this.newTaskForm.patchValue({
      authorizedSignatoryId: selectedItem.id
    });
  }

  onBenChange(selectedItem: any) {
    if (!selectedItem) return false;
    this.newTaskForm.patchValue({
      beneficiaryId: selectedItem.id ? selectedItem.id : selectedItem.beneficiaryEmployeeId,
      primaryApplicant: null
    });

    this.newTaskForm.get('primaryApplicant').updateValueAndValidity();
    //if (!!(this.newTaskForm.get('immCategoryCode').value && (this.newTaskForm.get('immCategoryCode').value === 'GCFLY' || this.newTaskForm.get('immClassificationCode').value === 'AFFDVTSUPT864')) || (this.newTaskForm.value.superTaskTypeCode === 'NONIMMPET' && this.dependentVisaArray.includes(this.newTaskForm.value.visaType)) && !this.newTaskForm.value.isSelfSponsor) {
    if (!!(this.newTaskForm.get('immCategoryCode').value && (['GCOTHER', 'GCFLY'].includes(this.newTaskForm.get('immCategoryCode').value) || this.newTaskForm.get('immClassificationCode').value === 'AFFDVTSUPT864')) || (this.newTaskForm.value.superTaskTypeCode === 'NONIMMPET' && this.dependentVisaArray.includes(this.newTaskForm.value.visaType)) && !this.newTaskForm.value.isSelfSponsor) {
      this.getDependents(this.userType == 'Beneficiary'? sessionStorage.getItem('beneficiaryId') : this.newTaskForm.value.beneficiaryId);
    }
  }

  // onChangeCreatingTaskFor(value: string){
  //   console.log(value, this.taskFor);
  //   this.isTaskForIndvdul = (value === 'individual');
  //   if(value !== this.taskFor ){
  //     this.taskFor = value;
  //     this.populateDefaultValues(true, {creatingTaskFor: value});
  //   }
  // }

  getDependents(benificiaryId: number, updateNew: boolean = false, newApplicantData: any = {}) {
    this.createTaskService.getDependentList(benificiaryId).pipe(takeUntil(this.destroy$)).subscribe((response) => {
      this.dependentList = response.map(x => {
        return {
          ...x,
          displayName: `${x.firstName} ${x.lastName} - ${x.relationshipName}`,
          isChecked: false,
          isPrimaryApplicant: false,
          email: x?.emailContacts?.length ? x.emailContacts[0].email : null
        };
      });
      // if(this.userType == 'Beneficiary') {
      //   this.dependentList.unshift({ 
      //     displayName: `${this.beneDetails.firstAndLastName}`,
      //     isChecked: false,
      //     isPrimaryApplicant: false,
      //     email: this.beneDetails?.emailContacts?.length ? this.beneDetails.emailContacts[0].email : null,
      //     id: this.beneDetails.id
      //   });
      // }
      if (this.newTaskForm.value?.visaType === 'K1') {
        this.dependentList = this.dependentList.filter(item => item.relationshipCode === 'FIANCE');
      } else if (this.newTaskForm.value?.visaType === 'K3') {
        this.dependentList = this.dependentList.filter(item => item.relationshipCode === 'SPOUSE');
      } else if (this.newTaskForm.value?.immCategoryCode && this.newTaskForm.value?.immCategoryCode === 'GCFLY') {
        if (this.newTaskForm.value?.immClassificationCode === 'REMVCONDTRES') {
          this.dependentList = this.dependentList.filter(item => ['SPOUSE', 'CHILD'].includes(item.relationshipCode));
        } else {
          this.dependentList = this.dependentList;
        }
      } else if (this.newTaskForm.value?.immClassificationCode &&
        ['WVRUNLAWPRSNCI601A', 'WVRINADMI601', 'AFFDVTSUPT864'].includes(this.newTaskForm.value?.immClassificationCode)) {
        this.dependentList = this.dependentList;
      } else {
        //this.dependentList = this.dependentList.filter(item => ['SPOUSE', 'CHILD'].includes(item.relationshipCode));
        this.dependentList = this.dependentList;
      }

      if (updateNew && newApplicantData) {
        const newApplicant = this.dependentList.find((dep) => dep.id && dep.id === newApplicantData.id);
        this.newTaskForm.patchValue({
          primaryApplicant: newApplicant || null
        });
        this.onDependentChange(newApplicant);
      }else{
        this.newTaskForm.patchValue({
          primaryApplicant: null
        });
      }
    });
  }

  filterDependents(event: any) {
    let query = event.query;
    let filtered = [];

    for (let i = 0; i < this.dependentList.length; i++) {
      let item = this.dependentList[i];      
      // Check if query matches any of the fields (displayName, email, or alienRegNo)
      if (
        (item.displayName && item.displayName.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
        (item.email && item.email.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
        (item.alienRegNo && item.alienRegNo.toLowerCase().indexOf(query.toLowerCase()) > -1)
      ) {
        filtered.push(item);
      }
    }

    this.filteredDependentList = filtered;
  }

  onDependentChange(selectedItem: any) {
    let primApplicantValue = this.newTaskForm.get('primaryApplicant').value;
    if(primApplicantValue){
      this.newTaskForm.get('primaryApplicant').setValue({ ...primApplicantValue, isPrimaryApplicant: true, primaryApplicant: true });
    }
    
  }

  handleSelfPetitionerChange(event: any) {
    this.newTaskForm.patchValue({
      company: null,
      companyId: null
    });
    // if(event.checked){
    //   this.getCompanies();
    // }
  }

  isDuplicatedtoggle(e: any, checked: boolean) {
    if (e === 'duplicated') {
      this.isDuplicatedData = checked;
    } else {
      this.newTaskForm.patchValue({
        isOutsideImagility: checked,
      });
    }
  }

  backToDashboard() {
    this.router.navigate([`../../${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}`]);
  }

  backToBeneficiaries() {
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[localStorage.getItem('userTypeRole')]}/beneficiaries/list`]);
  }

  onSubmit() {
    if (this.newTaskForm.value.isOutsideImagility) {
      this.saveTask();
    } else {
      //build steps for task
      this.getTaskTimeLineDetails();
    }
  }

  saveTask() {
    // this.isEnableDuplcateTable = true;
    //console.log(this.newTaskForm);
    let payload: any = this.newTaskForm.value;
    payload.immSpecialistId = null;
    let taskType = '';
    if (this.isImmigrant) {
      taskType = 'IMMPET';
    } else {
      taskType = 'NONIMMPET';
    }
    let tempApplicant = JSON.parse(JSON.stringify(payload.primaryApplicant));
    const visaType = payload.visaType;
    if (this.visaTemplateJson && this.visaTemplateJson.taskTypeId) {
      payload.superTaskTypeCode = payload.superTaskTypeCode;
      payload.visaTypeCode = payload.visaType;
      payload.petitionTypeCode = payload.petitionType;
      payload.immigrantTypeCode = "VISA";
      payload.serviceCenterId = payload?.serviceCenterId;
      payload.taskTypeCode = payload.taskTypeCode ? payload.taskTypeCode : this.newTaskForm.get('subTaskType').value;
      payload.questionAndResponseDTO = [];
      payload.companyId = (payload.companyId) ? payload.companyId : parseInt(sessionStorage.getItem('companyId'));
      payload.taskTypeId = this.visaTemplateJson && this.visaTemplateJson.taskTypeId ? this.visaTemplateJson.taskTypeId : null;
      payload.stepList = this.stepTaskTimelineList;
      payload.customStepList = this.customStepTaskTimelineList;
      if (payload.primaryApplicant && this.dependentList.length > 0) {
        const jsonInput = { applicantsList: [payload.primaryApplicant], primaryApplicant: payload.primaryApplicant };
        if (payload.immClassificationCode === 'AFFDVTSUPT864' && payload.primaryApplicant) {
          jsonInput.primaryApplicant.isPrimaryApplicant = true;
          jsonInput.primaryApplicant.primaryApplicant = true;
        }
        payload.jsonInput = JSON.stringify(jsonInput);
        delete payload.primaryApplicant;
      }
    } else {
      payload.stepList = this.stepTaskTimelineList;
      payload.customStepList = this.customStepTaskTimelineList;
    }

    payload.isOutsideImagility = payload.isOutsideImagility ? 1 : 0;
    payload['attorneyId'] = this.userType === 'Attorney' ? this.primaryCompanyId : payload?.attorneyId;
    if (visaType && this.visaTypeArray.includes(visaType) && !(this.visaTemplateJson && this.visaTemplateJson.taskTypeId)) {
      payload = {
        attorneyId: payload.attorneyId,
        immSpecialistId: payload?.immSpecialistId,
        isOutsideImagility: payload.isOutsideImagility,
        preparerAttorneyId: payload?.preparerAttorneyId,
        superTaskTypeCode: payload.superTaskTypeCode,
        taskTypeCode: payload.taskTypeCode,
        authorizedSignatoryId: payload.authorizedSignatoryId,
        beneficiaryId: payload.beneficiaryId,
        companyId: payload.companyId,
        immigrantTypeCode: 'VISA',
        petitionTypeCode: payload.petitionType,
        questionAndResponseDTO: [],
        visaTypeCode: visaType,
        companyRelationCode: payload?.companyRelationCode || null,
        foreignCompanyId: payload?.foreignCompanyId || null,
        treatyCountryCode: payload?.treatyCountry || null,
        id: 0,
        superTaskId: 0,
        stepList: this.stepTaskTimelineList,
        customStepList: this.customStepTaskTimelineList,
        serviceCenterId: payload?.serviceCenterId
      };
    } else if (visaType && this.OVisaTypeArray.includes(visaType)) {
      payload = {
        attorneyId: payload.attorneyId,
        immSpecialistId: payload?.immSpecialistId,
        isOutsideImagility: payload.isOutsideImagility,
        preparerAttorneyId: payload?.preparerAttorneyId,
        superTaskTypeCode: payload.superTaskTypeCode,
        taskTypeCode: payload.taskTypeCode,
        authorizedSignatoryId: payload.authorizedSignatoryId,
        beneficiaryId: payload.beneficiaryId,
        companyId: payload.companyId,
        immigrantTypeCode: 'VISA',
        petitionTypeCode: payload.petitionType,
        questionAndResponseDTO: [],
        visaTypeCode: visaType,
        extrAblDocEvdCatgCode: payload?.extrAblDocEvdCatgCode,
        fieldExtrAbltyCode: payload?.fieldExtrAbltyCode,
        applicableOptionCodes: payload?.applicableOptionCodes,
        stepList: this.stepTaskTimelineList,
        customStepList: this.customStepTaskTimelineList,
        serviceCenterId: payload?.serviceCenterId
      };
    } else if (payload.taskTypeCode === 'I130') {
      let immiCatCode = payload.immCategoryCode;
      payload = {
        attorneyId: payload.attorneyId,
        immSpecialistId: payload.immSpecialistId,
        isOutsideImagility: payload.isOutsideImagility,
        preparerAttorneyId: payload.preparerAttorneyId,
        superTaskTypeCode: payload.superTaskTypeCode,
        taskTypeCode: payload.taskTypeCode,
        authorizedSignatoryId: null,
        beneficiaryId: null,
        // companyId: null,
        companyId: immiCatCode == 'GCFLY' ? (this.userType == 'Attorney' ? payload.attorneyId : null) : null,
        id: 0,
        immigrantTypeCode: '',
        petitionTypeCode: '',
        questionAndResponseDTO: [],
        superTaskId: 0,
        visaTypeCode: '',
        familyId: payload.primaryApplicant ? payload.primaryApplicant.id : payload?.familyId,
        immCategoryCode: payload.immCategoryCode,
        immClassificationCode: payload.immClassificationCode,
        sponsorId: payload.beneficiaryId,
        stepList: this.stepTaskTimelineList,
        customStepList: this.customStepTaskTimelineList,
        serviceCenterId: payload?.serviceCenterId
      };
    }
    if (this.i485SuperTask) {
      payload['superTaskId'] = this.i485SuperTask.superTaskId;
    } else if (this.ds160SuperTask) {
      payload['superTaskId'] = this.ds160SuperTask.superTaskId;
    } else if (this.reSuperTask) {
      payload['superTaskId'] = this.reSuperTask.superTaskId;
    } else if (this.permSuperTask) {
      payload['superTaskId'] = this.permSuperTask.superTaskId;
    } else if (this.i140SuperTask) {
      payload['superTaskId'] = this.i140SuperTask.superTaskId;
    }
    // Autopopulate payload logic
    // if(this.isAutopopulate) {
    //   payload['isAutoPopulate'] = true;
    //   this.isAutopopulate['beneficiaryId'] = payload.beneficiaryId;
    //   this.isAutopopulate['companyId'] = payload.companyId;
    //   this.isAutopopulate.visaType = payload.visaTypeCode;
    // }
    // Autopopulate payload logic
    if (payload.taskTypeCode) {
      delete payload.subTaskType;
    }
    if (payload.immCategoryCode && payload.immClassificationCode) {
      delete payload.visaType;
      delete payload.petitionType;
    }
    if (payload.beneficiary) {
      delete payload.beneficiary;
    }
    if (payload.company) {
      delete payload.company;
    }
    if (payload.authorizedSignatory) {
      delete payload.authorizedSignatory;
    }
    if (!this.isCaseRequestCreateTask && this.userType === 'Petitioner') {
      payload['isCaseRequestInitiated'] = true;
      payload['attorneyId'] = this.newTaskForm.controls['attorneySelected'].value;
    }

    payload = {
      ...payload,
      isVDTemplate: this.isVDTemplate,
      isIndividualSponsor: this.isIndividualSponsor,
      companyId: payload.companyId == 0 && (['EB1ALIEN'].includes(this.newTaskForm.get('immClassificationCode').value) && this.isIndividualSponsor) ? parseInt(sessionStorage.getItem('companyId')): payload.companyId
    };

    if(this.userType == 'Beneficiary') {
      payload.isBeneficiaryIntiate = true;
      payload.loggedInUserCompanyId = payload.companyId;
      payload.sponsorId = +sessionStorage.getItem('beneficiaryId');
      payload.benInitFamilyId = tempApplicant?.id;
      if(payload.stepList) {
        delete payload.stepList;
      }
    }

    let req: any;
    switch (payload.taskTypeCode) {
      case 'RFE':
      case 'PERM':
      case 'I140':
      case 'RECEFF':
      case 'PWD':
      case 'PERMSET':
        req = this.petitionerService.saveTask(payload, this.immigrantType, taskType);
        break;
      case 'I130':
        req = this.petitionerService.saveVisa(payload, payload.taskTypeCode);
        break;
      case 'PWDEFILE':
      default:
        req = this.petitionerService.saveVisa(payload, this.isImmigrant ? payload.immCategoryCode : visaType);
        break;
    }
    req
      .pipe(take(1))
      .subscribe((response: any) => {
        if (response) {
          // AutoPopulate Logic
          let petitionTaskId = response.data;
          // if(this.isAutopopulate) {
          //   payload['isAutoPopulate'] = true;
          //   this.isAutopopulate['petitionTaskId'] = petitionTaskId;
          // }
          // AutoPopulate End

          const id = payload.taskTypeCode === 'RFE' ? response.data.superTaskId : response.data;
          if (['PETITION', 'I485', 'DS260', 'DS160', 'PWDEFILE', 'I129EFILING'].includes(payload.taskTypeCode) && payload.isOutsideImagility === 0) {
            this.petitionerService.getSuperTask(id)
              .pipe(
                take(1),
                mergeMap((superTaskOverView: TaskSummaryOverview) => {
                  if (!this.isCaseRequestCreateTask) {
                    let tempcaseTaskTypeId: any = superTaskOverView.subTaskList.find((x: any) => x.taskTypeId);
                    this.caseTaskTypeId = tempcaseTaskTypeId.taskTypeId;
                    if (this.selectedAttorneyCid) {
                      this.afterCreateTask.emit({
                        companyId: this.selectedAttorneyCid,
                        caseTaskTypeId: this.caseTaskTypeId,
                        superTaskId: response.data,
                        beneficiaryId: this.selectedBenDetails.beneficiaryEmployeeId,
                        lawFirmUserId: this.newTaskForm.controls['lawFirmSelected'].value,
                      });
                    }
                  }
                  return this.createTaskService.createPetition(
                    this.isImmigrant ? payload.immCategoryCode : visaType,
                    {
                      beneficiaryId: this.userType == 'Beneficiary'? +sessionStorage.getItem('beneficiaryId') : superTaskOverView.superTask.beneficiaryId,
                      companyId: superTaskOverView.superTask.companyId,
                      employeeId: sessionStorage.getItem('employeeId') && sessionStorage.getItem('employeeId') != 'null'? sessionStorage.getItem('employeeId') : null,
                      taskId: superTaskOverView.subTaskList.find(x => x.taskTypeCode === payload.taskTypeCode).id,
                      consulateId: payload?.consulateId || null
                    },
                    this.userType == 'Beneficiary' ? true : false
                  );
                })
              )
              .pipe(take(1))
              .subscribe((petitionResponse: any) => {
                // Autopulate Logic
                //  if(this.isAutopopulate){
                //     this.isAutopopulate['petitionId'] = petitionResponse.PetitionId;
                //     this.petitionerService.postAutoPopulateData(this.isAutopopulate).subscribe( data => {
                //       this.toast.success('Data AutoPopulated Successfully');
                //     })
                //   }
                // Autopulate Logic

                if (!this.isCaseRequestCreateTask) {
                  console.log('responseresponse00', petitionResponse);
                } else {
                  this.toast.success(response.message, 'Success');
                  this.newTaskForm.reset({});
                  if (sessionStorage.getItem('requestDataDocument')) {
                    this.redirectToRequestDataDocument();
                  } else {
                    this.store.dispatch(new Task.SetTaskRouteId(id));
                    if(this.userType == 'Beneficiary') {
                      this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-overview`]);
                    } else {
                    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-details`]);
                    }
                  }
                }

              });
          } else {
            if (!this.isCaseRequestCreateTask) {
              if (response.data) {
                this.apiDocService.getSuperTask(response.data).subscribe(resData => {
                  let tempcaseTaskTypeId: any = resData.subTaskList.find((x: any) => x.taskTypeCode == this.newTaskForm.value.taskTypeCode);
                  if (this.selectedAttorneyCid) {
                    this.afterCreateTask.emit({
                      companyId: this.selectedAttorneyCid,
                      caseTaskTypeId: tempcaseTaskTypeId.taskTypeId,
                      superTaskId: resData.superTask.superTaskId,
                      beneficiaryId: this.selectedBenDetails.beneficiaryEmployeeId,
                      lawFirmUserId: this.newTaskForm.controls['lawFirmSelected'].value,
                    });
                  }
                })
              }
            } else {
              this.toast.success(response.message, 'Success');
              this.newTaskForm.reset({});
              if (sessionStorage.getItem('requestDataDocument')) {
                this.redirectToRequestDataDocument();
              } else {
                this.store.dispatch(new Task.SetTaskRouteId(id));
                this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-details`]);
              }
            }
          }
        }
      });
  }

  redirectToRequestDataDocument() {
    if (this.userType === 'Attorney') {
      this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/attorney/request-data`, { createTask: true }]);
    } else if (this.userType === 'Petitioner') {
      this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/beneficiaries/request-data`, { createTask: true }]);
    }
  }


  getAddComponent(componentName: string): any {
    if (componentName) {
      switch (componentName) {
        case 'addClientCompany':
          this.dynamicModalData = { attorneyId: this.userType === 'Attorney' ? this.primaryCompanyId : null };
          return AddClientCompanyComponent;
        case 'addPrimaryContact':
          this.dynamicModalData = { companyId: this.newTaskForm.value.companyId };
          return AddPrimaryContactComponent;
        case 'addBeneficiary':
        case 'addMember':
          const isSponsor = (!!(this.newTaskForm.get('immCategoryCode').value && this.newTaskForm.get('immCategoryCode').value === 'GCFLY') || this.dependentVisaArray.includes(this.newTaskForm.get('visaType').value) || this.newTaskForm.get('immClassificationCode').value === 'AFFDVTSUPT864') && !this.newTaskForm.get('isSelfSponsor').value && componentName === 'addBeneficiary' ? true : false;
          this.dynamicModalData = { companyId: this.foreignFields?.showForeignCompany ? this.newTaskForm.value.foreignCompanyId : (this.newTaskForm.value.companyId ? this.newTaskForm.value.companyId : this.primaryCompanyId), isAddingMember: false, isAddingSponsor: isSponsor };
          if (componentName === 'addMember') {
            this.dynamicModalData = { ...this.dynamicModalData, isAddingMember: true, isBeneficiaryInitiated: this.userType === 'Beneficiary'? true: false, beneficiaryId: this.userType === 'Beneficiary'? sessionStorage.getItem('beneficiaryId') : this.newTaskForm.value.beneficiaryId };
          }
          return AddBeneficiaryOrMemberComponent;
        default:
          return '';
      }
    }
  }

  handleAddClick(addFlag: string = '') {
    if(this.userType=='Attorney'){
      sessionStorage.setItem('createCompanyAttorney', 'true');
    }
    this.dynamicDialogRef = this.dialogService.open(this.getAddComponent(addFlag), {
      width: '60%',
      contentStyle: { 'z-index': '1000', 'padding-bottom': '15px', 'overflow-y': 'hidden !important' },
      styleClass: 'create-task-new-dialog',
      closable: false,
      showHeader: false,
      closeOnEscape: false,
      modal: true,
      dismissableMask: true,
      data: this.dynamicModalData
    });
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  getTaskTimeLineDetails() {
    let payload: any = {};
    let visaType: string = '';
    if (this.visaTemplateJson && this.visaTemplateJson.taskTypeId) {
      //Steps for VD visas
      let selectedCompany = (this.newTaskForm.value?.immCategoryCode === 'GCFLY') ? this.newTaskForm.value.attorneyId : this.newTaskForm.value.companyId;
      if (this.userType == 'Attorney') {
        if (selectedCompany == 0) {
          selectedCompany = this.newTaskForm.value.attorneyId
        }
      }
      if (this.newTaskForm.value.visaType) {
        visaType = this.newTaskForm.value.visaType;
      } else {
        visaType = this.newTaskForm.value.immCategoryCode;
      }
      payload = {
        immigrationCategory: this.newTaskForm.value.immCategoryCode,
        immigrationClassification: this.newTaskForm.value.immClassificationCode,
        immigrationType: "VISA",
        parentStepId: 0,
        petitionType: this.newTaskForm.value.petitionType,
        taskType: this.newTaskForm.value.taskTypeCode,
        superTaskType: this.newTaskForm.value.superTaskTypeCode,
        visaType: this.newTaskForm.value.visaType,
        companyId: selectedCompany,
        taskTypeId: this.visaTemplateJson.taskTypeId
      };
    } else {
      //Steps for Non-VD visas
      if (this.newTaskForm.value.visaType) {
        visaType = this.newTaskForm.value.visaType;
      } else {
        visaType = this.newTaskForm.value.immCategoryCode;
      }
      payload = {
        immigrationCategory: this.newTaskForm.value.immCategoryCode,
        immigrationClassification: this.newTaskForm.value.immClassificationCode,
        immigrationType: "VISA",
        parentStepId: 0,
        petitionType: this.newTaskForm.value.petitionType,
        taskType: this.newTaskForm.value.subTaskType,
        superTaskType: this.newTaskForm.value.superTaskTypeCode,
        visaType: this.newTaskForm.value.visaType,
        companyId: this.newTaskForm.value.companyId,
        templateType: this.templateType === "CWF" ? "CWF" : null
      };
    }
    this.stepTaskTimelineList = [];
    this.customStepTaskTimelineList = [];
    this._taskAllocationService
      .postTaskTimelineDetails(visaType, payload)
      .subscribe((res: any) => {
        let companyId = (this.newTaskForm.value.companyId) ? this.newTaskForm.value.companyId : parseInt(sessionStorage.getItem('companyId'))
        //this.stepLineDetailsData = res;
        this.stepTaskTimelineList = res?.data?.stepList.filter(d => !d.isCustomStep) || [];
        if (res?.data?.taskTypeId && this.userType !== 'Beneficiary') {
          this.customQuestionsService.getCustomStepsDetails(companyId, res.data.taskTypeId).subscribe((masterRes: any) => {
            this.customStepTaskTimelineList = masterRes.customStepList;
            this.stepTaskTimelineList.forEach((e) => {
              if (e.durationUnit === null) {
                e.durationUnit = "DAY";
              }
              if (e.duration === null) {
                e.duration = "1";
              }
              if (e.isBeneficiaryAction === 1) {
                e.assignToBeneficiary = (e.assignToEmployee) ? e.assignToEmployee : e.assignToBeneficiary;
              }
            });
            if (this.customStepTaskTimelineList.length > 0) {
              this.customStepTaskTimelineList.forEach((e) => {
                if (e.durationUnit === null) {
                  e.durationUnit = "DAY";
                }
                if (e.duration === null) {
                  e.duration = "1";
                }
                if (e.isBeneficiaryAction === 1) {
                  e.assignToBeneficiary = (e.assignToEmployee) ? e.assignToEmployee : e.assignToBeneficiary;
                }
              });
            }
            //Save the task
            this.saveTask();
          });
        } else {
          //Save the task
          this.saveTask();
        }
      });
  }

  onChangeSelfSponsor(event: any) {
    this.newTaskForm.patchValue({
      primaryApplicant: null
    });
    this.newTaskForm.get('primaryApplicant').updateValueAndValidity();
  }
  handleClose() {
    this.showWarningMessage = false;
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.formChangesSubscriptions) {
      this.formChangesSubscriptions.forEach(item => { item.unsubscribe(); });
    }
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    sessionStorage.removeItem('createCompanyAttorney');
  }
}
